const ja = {
  'common.loading': '読み込み中…',
  'common.save': '保存',
  'common.cancel': 'キャンセル',
  'common.delete': '削除',
  'common.search': '検索',
  'common.accessDenied': 'アクセスが拒否されました',
  'common.backToLogin': 'ログインに戻る',
  'common.markAsRead': '既読にする',
  'shell.supportDesk': 'サポートデスク',
  'shell.searchPlaceholder': 'チケット、連絡先、記事を検索…',
  'shell.newTicket': '新しいチケット',
  'shell.notifications': '通知',
  'shell.notificationPreferences': '通知設定',
  'shell.settings': '設定',
  'shell.signOut': 'ログアウト',
  'shell.expandNavigation': 'ナビゲーションを展開',
  'shell.collapseNavigation': 'ナビゲーションを折りたたむ',
  'shell.caughtUp': 'すべて確認済みです',
  'shell.viewAllNotifications': 'すべての通知を見る',
  'nav.dashboard': 'ダッシュボード',
  'nav.tickets': 'チケット',
  'nav.contacts': '連絡先',
  'nav.companies': '会社',
  'nav.reports': 'レポート',
  'nav.settings': '設定',
  'nav.agents': 'エージェント',
  'nav.groups': 'グループ',
  'nav.roles': 'ロール',
  'nav.tags': 'タグ',
  'nav.ticketFields': 'チケット項目',
  'nav.ticketForms': 'チケットフォーム',
  'nav.businessHours': '営業時間',
  'nav.slaPolicies': 'SLAポリシー',
  'nav.automations': '自動化',
  'nav.email': 'メール',
  'nav.notificationTemplates': '通知テンプレート',
  'nav.apiKeys': 'APIキー',
  'nav.cannedResponses': '定型返信',
  'nav.knowledgeBase': 'ナレッジベース',
  'auth.signInTitle': 'SDPLサポートデスク',
  'auth.signInSubtitle': 'アカウントにログイン',
  'auth.emailAddress': 'メールアドレス',
  'auth.password': 'パスワード',
  'auth.signingIn': 'ログイン中…',
  'auth.signIn': 'ログイン',
  'auth.forgotPassword': 'パスワードをお忘れですか？',
  'auth.twoFactor': '二要素認証',
  'auth.verificationCode': '確認コード',
  'auth.verify': '確認',
  'auth.backToLogin': 'ログインに戻る',
  'agents.title': 'エージェント',
  'agents.new': '新しいエージェント',
  'agents.supportAgents': 'サポートエージェント',
  'agents.collaborators': 'コラボレーター',
  'agents.deactivated': '無効',
  'agents.searchPlaceholder': '名前またはメールで検索',
  'agents.edit': '編集',
  'agents.deactivate': '無効にする',
  'agents.reactivate': '再有効化',
  'agents.saved': 'エージェントを保存しました。',
  'agents.firstName': '名',
  'agents.lastName': '姓',
  'agents.email': 'メール',
  'agents.phone': '電話番号',
  'agents.timezone': 'タイムゾーン',
  'agents.selectTimezone': 'タイムゾーンを選択',
  'agents.language': '言語',
  'agents.selectLanguage': '言語を選択',
  'agents.emailSignature': 'メール署名',
  'agents.roleRequired': 'ロール',
  'agents.selectRole': 'ロールを選択',
  'agents.status': 'ステータス',
  'agents.groupsTitle': 'グループ',
  'agents.manageGroups': 'グループを管理',
  'agents.notInGroup': 'まだグループに所属していません',
  'dashboard.title': 'ダッシュボード',
  'dashboard.description': '現在のサポート負荷とサービス状況。',
  'dashboard.allGroups': 'アクセス可能なすべてのグループ',
  'dashboard.unresolved': '未解決',
  'dashboard.overdue': '期限超過',
  'dashboard.dueToday': '本日期限',
  'dashboard.open': 'オープン',
  'dashboard.onHold': '保留中',
  'dashboard.unassigned': '未割り当て',
  'dashboard.trends': '今日の傾向',
  'notifications.title': '通知',
  'notifications.description': '通知の全履歴。',
  'notifications.markAllRead': 'すべて既読にする',
  'notifications.filter': 'フィルター',
  'notifications.allTypes': 'すべての種類',
  'notifications.none': '通知はまだありません',
  'notifications.assigned': '割り当て',
  'notifications.reply': '返信',
  'notifications.note': 'メモ',
  'notifications.slaWarning': 'SLA警告',
  'notifications.slaBreach': 'SLA違反',
  'notifications.slaEscalation': 'SLAエスカレーション',
  'notifications.mention': 'メンション',
  'preferences.title': '通知設定',
  'preferences.description': 'アプリ内通知は常に有効です。メールでも受け取る通知を選択してください。',
  'preferences.emailDigest': 'メールダイジェスト',
  'preferences.dailySummary': 'イベントごとのメールの代わりに、毎日1通の概要メールを受け取ります。',
  'preferences.digestOff': 'オフ — イベントごとにメール',
  'preferences.digestDaily': '毎日のダイジェスト',
  'preferences.emailNotifications': 'メール通知',
  'activities.button': '最近のアクティビティ',
  'activities.title': '最近のアクティビティ',
  'activities.loadError': '最近のアクティビティを読み込めませんでした。',
  'activities.systemActor': 'システム',
  'activities.noneTitle': '最近のアクティビティはまだありません',
  'activities.noneDescription': 'あなたとあなたのグループのチケット更新は、発生するとここに表示されます。',
  'tickets.title': 'チケット',
  'tickets.description': 'アクセス権のあるすべてのチケットを、必要に応じて絞り込み・並べ替えできます。',
  'tickets.dueDateTabs': 'チケットの期限',
  'tickets.tabAll': 'すべてのチケット',
  'tickets.tabDueToday': '本日期限',
  'tickets.tabOverdue': '期限超過',
  'tickets.tabDueTomorrow': '明日期限',
  'tickets.searchPlaceholder': 'チケットを検索…',
  'tickets.searchAria': 'チケットを検索',
  'tickets.filters': 'フィルター',
  'tickets.filtersWithCount': 'フィルター ({count})',
  'tickets.sortAria': 'チケットの並べ替え基準',
  'tickets.sortTrigger': '並べ替え: {label}',
  'tickets.sortDateCreated': '作成日',
  'tickets.sortDateUpdated': '更新日',
  'tickets.sortPriority': '優先度',
  'tickets.sortStatus': 'ステータス',
  'tickets.sortDueDate': '期限',
  'tickets.sortAscending': '昇順で並べ替え',
  'tickets.sortDescending': '降順で並べ替え',
  'tickets.ascending': '昇順',
  'tickets.descending': '降順',
  'tickets.layoutAria': '行レイアウト',
  'tickets.layoutTrigger': 'レイアウト: {label}',
  'tickets.layoutCard': 'カード',
  'tickets.layoutInbox': '受信トレイ',
  'tickets.layoutTable': 'テーブル',
  'tickets.export': 'エクスポート',
  'tickets.exportSelected': '選択項目をエクスポート',
  'tickets.selectedCount': '{count} 件選択中',
  'tickets.assignAgent': 'エージェントを割り当て',
  'tickets.closeAll': 'すべて閉じる',
  'tickets.clearSelection': '選択を解除',
  'tickets.selectAgentPlaceholder': 'エージェントを選択...',
  'tickets.assignTo': '割り当て先',
  'tickets.assign': '割り当て',
  'tickets.loadFailed': 'チケットを読み込めませんでした。再度お試しください。',
  'tickets.bulkCloseFailed': '選択したチケットを閉じられませんでした。再度お試しください。',
  'tickets.bulkAssignFailed': '選択したチケットを割り当てられませんでした。再度お試しください。',
  'tickets.noFilterMatchTitle': 'これらのフィルターに一致するチケットはありません',
  'tickets.noFilterMatchDescription': 'フィルターを削除するか、日付範囲を広げるか、別の検索語を試してください。',
  'tickets.clearFilters': 'フィルターをクリア',
  'tickets.queueClearTitle': 'このキューは空です',
  'tickets.queueClearDescription': '顧客がメールを送信、ポータルを利用、またはエージェントが作成すると、新しいチケットがここに表示されます。',
  'tickets.newTicket': '新規チケット',
  'tickets.selectAllAria': 'すべてのチケットを選択',
  'tickets.selectTicketAria': 'チケット #{number} を選択',
  'tickets.columnContact': '連絡先',
  'tickets.columnSubject': '件名',
  'tickets.columnState': '状態',
  'tickets.columnGroup': 'グループ',
  'tickets.columnAgent': 'エージェント',
  'tickets.columnPriority': '優先度',
  'tickets.noGroup': 'グループなし',
  'tickets.unassigned': '未割り当て',
  'tickets.createdRelative': '{when}に作成',
  'tickets.unassignedOnly': '未割り当てのみ',
  'tickets.unknownRequester': '不明な依頼者',
  'tickets.overdueBy': '{duration}期限超過',
  'tickets.dueIn': '{duration}後に期限',
  'tickets.filtersDrawerTitle': 'フィルター',
  'tickets.filtersSearchPlaceholder': 'フィールドを検索',
  'tickets.filtersSearchAria': 'フィルターフィールドを検索',
  'tickets.filtersClearAll': 'すべてクリア',
  'tickets.filtersApply': '適用',
  'tickets.filterAgents': 'エージェント',
  'tickets.filterAnyAgent': '任意のエージェント',
  'tickets.filterGroups': 'グループ',
  'tickets.filterAnyGroup': '任意のグループ',
  'tickets.filterStatus': 'ステータス',
  'tickets.filterAnyStatus': '任意のステータス',
  'tickets.filterPriority': '優先度',
  'tickets.filterAnyPriority': '任意の優先度',
  'tickets.filterSource': 'ソース',
  'tickets.filterAnySource': '任意のソース',
  'tickets.filterTicketType': 'チケットタイプ',
  'tickets.filterAnyType': '任意のタイプ',
  'tickets.filterTags': 'タグ',
  'tickets.filterAnyTag': '任意のタグ',
  'tickets.filterCompanies': '会社',
  'tickets.filterAnyCompany': '任意の会社',
  'tickets.filterCreated': '作成日',
  'tickets.filterResolvedAt': '解決日',
  'tickets.filterClosedAt': '終了日',
  'tickets.filterDateFrom': '{label}開始',
  'tickets.filterDateTo': '{label}終了',
  'tickets.filterDateTo2': '終了',
  'tickets.filterAny': '任意',
  'tickets.chipFieldStatus': 'ステータス',
  'tickets.chipFieldPriority': '優先度',
  'tickets.chipFieldGroup': 'グループ',
  'tickets.chipFieldAssignee': '担当者',
  'tickets.chipValueGroup': 'グループ',
  'tickets.chipValueUnassigned': '未割り当て',
  'common.saving': '保存中…',
  'common.clearSearch': '検索をクリア',
  'common.sortBy': '並べ替え',
  'common.name': '名前',
  'common.role': 'ロール',
  'common.groups': 'グループ',
  'common.tickets': 'チケット',
  'common.lastSeen': '最終ログイン',
  'common.actions': '操作',
  'common.never': 'なし',
  'common.justNow': '今',
  'common.minutesAgo': '{count}分前',
  'common.hoursAgo': '{count}時間前',
  'common.daysAgo': '{count}日前',
  'common.noPagePermission': 'このページにアクセスする権限がありません。',
  'common.roleNoPermission': 'お客様のロールにはこのページへのアクセス権限がありません。',
  'common.requestFailed': 'リクエストに失敗しました。再度お試しください。',
  'common.unexpectedError': '予期しないエラーが発生しました',
  'common.user': 'ユーザー',
  'shell.skipToMain': 'メインコンテンツへスキップ',
  'shell.homeLabel': 'Suzuki Support Desk ホーム',
  'shell.userMenu': 'ユーザーメニュー',
  'shell.unread': '未読 {count} 件',
  'shell.adminNavigation': '管理者ナビゲーション',
  'shell.notificationDescription': '新しい割り当て、返信、SLAアラートがここに表示されます。',
  'auth.enterAuthenticatorCode': '認証アプリの6桁のコードを入力してください',
  'auth.verifying': '確認中…',
  'auth.setupAuthenticator': '認証アプリを設定',
  'auth.scanAuthenticator': '認証アプリ（Google Authenticator、Authyなど）でこのコードをスキャンしてください',
  'auth.authenticatorSetupQr': '認証アプリ設定用QRコード',
  'auth.verificationCodeFromAuthenticator': '認証アプリからの確認コード',
  'auth.verifyAndComplete': '確認して設定を完了',
  'auth.loadingSetup': '設定を読み込み中…',
  'auth.setNewPassword': '新しいパスワードを設定',
  'auth.temporaryPasswordExpired': '仮パスワードの有効期限が切れました。新しいパスワードを設定してください。',
  'auth.newPassword': '新しいパスワード',
  'auth.confirmPassword': 'パスワードの確認',
  'auth.settingPassword': 'パスワードを設定中…',
  'auth.setPassword': 'パスワードを設定',
  'auth.passwordRequirements': '8文字以上、大文字、小文字、数字、記号が必要です',
  'auth.tooManyAttempts': 'ログイン試行回数が多すぎます。しばらくしてから再度お試しください。',
  'auth.invalidCredentials': 'メールアドレスまたはパスワードが無効です',
  'auth.passwordsDoNotMatch': 'パスワードが一致しません',
  'auth.passwordMinimum': 'パスワードは{count}文字以上必要です',
  'auth.resetTitle': 'パスワードをリセット',
  'auth.resetSubtitle': 'メールアドレスを入力すると、リセットリンクを送信します',
  'auth.checkEmail': 'メールでリセットリンクを確認してください',
  'auth.checkCode': 'メールで確認コードを確認してから、下のフォームに進んでください。',
  'auth.continueToReset': 'パスワードのリセットを続ける',
  'auth.sendResetLink': 'リセットリンクを送信',
  'auth.sending': '送信中…',
  'auth.resetSuccess': 'パスワードが正常にリセットされました。',
  'auth.goToLogin': 'ログインへ',
  'auth.missingResetToken': 'リセットトークンがありません。メールのリンクをご利用ください。',
  'auth.enterCodeFromEmail': 'メールに送信された確認コードを入力してください',
  'auth.codeFromEmail': 'メールのコードを入力',
  'auth.emailRequired': 'メールアドレスは必須です',
  'auth.codeRequired': '確認コードは必須です',
  'auth.missingToken': 'リセットトークンがありません',
  'auth.failedReset': 'パスワードのリセットに失敗しました。',
  'auth.resetting': 'リセット中…',
  'auth.resetPassword': 'パスワードをリセット',
  'auth.looksGood': '問題ありません',
  'auth.needCharacters': '最低{count}文字必要です',
  'auth.passwordFormat': '{count}文字以上、大文字、小文字、数字、記号が必要です',
  'agents.description': 'チケットを処理する担当者です。ロールで操作を制御し、グループで表示範囲を制御します。',
  'agents.searchAria': 'エージェントを検索',
  'agents.countOne': '{count} 人のエージェント',
  'agents.countMany': '{count} 人のエージェント',
  'agents.ticketOne': '{count} 件のチケット',
  'agents.ticketMany': '{count} 件のチケット',
  'agents.noGroups': 'グループなし',
  'agents.lifecycle': 'エージェントのライフサイクル',
  'agents.noSearchResults': 'この検索に一致するエージェントはいません',
  'agents.noAgentsView': 'このビューにはエージェントがいません',
  'agents.tryDifferent': '別の名前またはメールアドレスをお試しください。',
  'agents.useNewAgent': '新しいエージェントを使って追加するか、タブを切り替えて他のエージェントを表示してください。',
  'agents.agent': 'エージェント',
  'agents.noRole': 'ロールなし',
  'agents.openTicketsTitle': '現在このエージェントに割り当てられているオープンチケット',
  'agents.moreActions': '{name}のその他の操作',
  'agents.confirmDeleteTitle': '{name}を削除しますか？',
  'agents.confirmDeleteDescription': 'この操作は取り消せません。チケットに関連付けられたエージェントは削除できません。代わりに無効化してください。',
  'agents.confirmDeleteLabel': 'エージェントを削除',
  'agents.agentsVsCollaborators': 'エージェントとコラボレーターの違い',
  'agents.agentsVsCollaboratorsBody': 'サポートエージェントは日常的にチケットを処理します。コラボレーターはコラボレーターロールを持ち、通常は完全なエージェントアクセス権なしで個別のチケットに参加する専門家です。',
  'agents.deactivateVsDelete': '無効化と削除の違い',
  'agents.deactivateVsDeleteBody': '無効化すると履歴とチケットの所有権は保持されますがログインがブロックされます。削除は永久的で、エージェントに関連チケットがない場合のみ機能します。',
  'agents.newTitle': '新しいエージェント',
  'agents.editTitle': 'エージェントを編集',
  'agents.temporaryPassword': '仮パスワード',
  'agents.passwordHelp': '12文字以上。エージェントはログイン後に変更できます。',
  'agents.timezoneHelp': 'このエージェントに表示される日付と時刻はすべてこのタイムゾーンで表示されます。',
  'agents.languageHelp': 'エージェント向けインターフェースを翻訳します。チケットの返信や顧客のコンテンツは翻訳されません。',
  'agents.signaturePlaceholder': '送信する返信に追加されます',
  'agents.roleHelp': 'このエージェントが実行できる操作を決定します。',
  'agents.manageRoles': 'ロールを管理',
  'agents.activeHelp': '有効 — チェックを外すとエージェントを削除せずにログインをブロックします',
  'agents.groupHelp': 'グループ画面からこのエージェントをグループに追加して、表示されるチケットを制御してください。',
  'agents.about': 'このエージェントについて',
  'agents.aboutBody': '名前、メール、電話、タイムゾーン、言語、署名がエージェントを識別し、ワークスペースをパーソナライズします。ロールは実行できる操作を制御し、グループメンバーシップは表示されるチケットを制御します。',
  'dashboard.trendsDescription': 'UTC時間別のチケット作成数を昨日と比較します。',
  'dashboard.today': '今日',
  'dashboard.yesterday': '昨日',
  'dashboard.chartAria': 'UTC時間別のチケット量、今日対昨日',
  'dashboard.dataUnavailable': 'ダッシュボードのデータは利用できません。',
  'dashboard.loadError': 'ダッシュボードデータを読み込めませんでした。再度お試しください。',
  'notifications.noType': 'このタイプの通知はありません',
  'notifications.allTypesHint': '上の「すべての種類」を選択すると、履歴の残りを確認できます。',
  'notifications.emptyDescription': '割り当て、返信、SLAアラートがここに届きます。通知設定でどれをメール送信するか調整してください。',
  'preferences.digestWarning': '毎日のダイジェストを使用しているため、これらの設定はオフにするまで無視されます。',
  'preferences.assignedEvent': 'チケットが割り当てられたとき',
  'preferences.replyEvent': '参加しているチケットに返信があったとき',
  'preferences.noteEvent': 'プライベートメモが追加されたとき',
  'preferences.slaWarningEvent': 'SLAの期限が近づいているとき',
  'preferences.slaBreachEvent': 'SLAが違反されたとき',
  'preferences.slaEscalationEvent': 'SLAが期限を過ぎてエスカレーションしたとき',
  'preferences.mentionEvent': 'チケットでメンションされたとき',

  'ticketDetail.back': '戻る',
  'ticketDetail.follow': 'フォロー',
  'ticketDetail.following': 'フォロー中',
  'ticketDetail.hideActivities': 'アクティビティを非表示',
  'ticketDetail.activitiesButton': 'アクティビティ',
  'ticketDetail.attachmentsCount': '添付ファイル ({count})',
  'ticketDetail.threadAria': 'チケットスレッド',
  'ticketDetail.conversationsTabLabel': '会話',
  'ticketDetail.activitiesTabLabel': 'アクティビティ',
  'ticketDetail.noRepliesYet': 'まだ返信はありません',
  'ticketDetail.noRepliesDescription': '下のエディタを使用して依頼者に返信するか、内部メモを追加してください。',
  'ticketDetail.privateNote': 'プライベートメモ',
  'ticketDetail.forward': '転送',
  'ticketDetail.uploadingAria': 'アップロード中',
  'ticketDetail.uploadingProgress': '{total}件中{uploading}件のファイルをアップロード中…',
  'ticketDetail.uploadsFailed': '{count}件のアップロードに失敗しました',
  'ticketDetail.retry': '再試行',
  'ticketDetail.dismiss': '閉じる',
  'ticketDetail.noActivityYet': 'まだアクティビティはありません',
  'ticketDetail.noActivityDescription': 'ステータス、エージェント、SLAの変更はチケットの進行に応じてここに表示されます。',
  'ticketDetail.requester': '依頼者',
  'ticketDetail.properties': 'プロパティ',
  'ticketDetail.updating': '更新中…',
  'ticketDetail.update': '更新',
  'ticketDetail.tags': 'タグ',
  'ticketDetail.relationships': '関連付け',
  'ticketDetail.parentTicket': '親チケット',
  'ticketDetail.unlink': 'リンク解除',
  'ticketDetail.noParentTicket': '親チケットなし',
  'ticketDetail.childTicketsCount': '子チケット ({count})',
  'ticketDetail.noChildTickets': '子チケットなし',
  'ticketDetail.findTicket': 'チケットを検索',
  'ticketDetail.ticketSearchPlaceholder': 'チケット番号または件名',
  'ticketDetail.searchButton': '検索',
  'ticketDetail.setParent': '親として設定',
  'ticketDetail.mergeIntoAction': 'マージ先',
  'ticketDetail.splitIntoChild': '子チケットに分割',
  'ticketDetail.newTicketSubjectPlaceholder': '新しいチケットの件名',
  'ticketDetail.splitButton': '分割',
  'ticketDetail.copyAttachments': '添付ファイルをコピー',
  'ticketDetail.copyConversationHistory': '会話履歴をコピー',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': '一時停止中',
  'ticketDetail.editButton': '編集',
  'ticketDetail.setResolutionDueDate': '解決期限を設定',
  'ticketDetail.pickDateTime': '日時を選択',
  'ticketDetail.resolutionDueLabel': '解決期限',
  'ticketDetail.saveSla': 'SLAを保存',
  'ticketDetail.savingSla': '保存中…',
  'ticketDetail.noSlaPolicy': 'このチケットにはSLAポリシーが適用されていません。',
  'ticketDetail.firstResponse': '初回応答',
  'ticketDetail.resolution': '解決',
  'ticketDetail.done': '完了',
  'ticketDetail.pausedSince': '{date}から一時停止中',
  'ticketDetail.escalation': 'エスカレーション',
  'ticketDetail.escalatedLevel2': 'エスカレーション済み（レベル2）',
  'ticketDetail.escalated': 'エスカレーション済み',
  'ticketDetail.dueDateOverridden': '期限は管理者によって手動で上書きされました。',
  'ticketDetail.dates': '日付',
  'ticketDetail.created': '作成日',
  'ticketDetail.updated': '更新日',
  'ticketDetail.resolved': '解決日',
  'ticketDetail.closed': '終了日',
  'ticketDetail.loadErrorTitle': 'このチケットを読み込めませんでした',
  'ticketDetail.notFound': 'チケットが見つかりません',
  'ticketDetail.confirmMergeTitle': 'チケット #{source} を #{target} にマージしますか？',
  'ticketDetail.confirmMergeDescription': '現在のチケットは終了します。この操作は取り消せません。',
  'ticketDetail.confirmMergeLabel': 'チケットをマージ',
  'ticketDetail.updateSuccess': 'チケットを更新しました',
  'ticketDetail.updateError': 'チケットを更新できません',
  'ticketDetail.pickDateTitle': '日付を選択',
  'ticketDetail.pickDateDescription': '解決期限を選択してください。',
  'ticketDetail.slaUpdateSuccess': 'SLAを更新しました',
  'ticketDetail.slaUpdateError': 'SLAを更新できません',
  'ticketDetail.searchError': 'チケットを検索できません',
  'ticketDetail.parentUpdateError': '親チケットを更新できません',
  'ticketDetail.mergeSuccess': '#{number} にマージしました',
  'ticketDetail.mergeError': 'チケットをマージできません',
  'ticketDetail.splitSuccess': 'チケットの分割を作成しました',
  'ticketDetail.splitError': 'チケットを分割できません',
  'ticketDetail.downloadError': '添付ファイルをダウンロードできません',
  'ticketDetail.followSuccess': 'チケットをフォローしました',
  'ticketDetail.unfollowSuccess': 'チケットのフォローを解除しました',
  'ticketDetail.watcherError': 'フォロー状態を更新できません',
  'ticketDetail.fieldsLoadError': 'チケットフィールドを読み込めません',
  'ticketDetail.overdueBy': '{label}遅延',
  'ticketDetail.dueLeft': '残り{label}',
  'ticketDetail.presetToday': '今日',
  'ticketDetail.presetTomorrow': '明日',
  'ticketDetail.presetThisWeek': '今週',
  'ticketDetail.presetNextWeek': '来週',
  'ticketDetail.presetThisMonth': '今月',
  'ticketDetail.eventTicketCreated': 'チケット作成',
  'ticketDetail.eventStatusUpdated': 'ステータス更新',
  'ticketDetail.eventAgentUpdated': 'エージェント更新',
  'ticketDetail.eventSlaUpdated': 'SLA更新',
  'ticketDetail.eventTicketMerged': 'チケットマージ',
  'ticketDetail.eventMergeReceived': 'マージ受信',
  'ticketDetail.eventTicketSplit': 'チケット分割',
  'ticketDetail.eventUpdated': '更新',
  'ticketDetail.eventSplitContentCopied': '分割コンテンツをコピー',
  'ticketDetail.eventReplySent': '返信送信',
  'ticketDetail.eventNoteAdded': 'メモ追加',
  'ticketDetail.eventCustomerReplied': '顧客が返信',
  'ticketDetail.eventTicketDeleted': 'チケット削除',
  'preferences.createdEvent': 'チケットが作成されました',
  'preferences.pendingInputEvent': 'チケットが返信を待っています',
  'preferences.resolvedEvent': 'チケットが解決されました',
  'agents.assignGroups': 'グループを割り当て',
  'agents.assignGroupsHelp': 'グループメンバーシップによって、このエージェントが表示できるチケットが決まります。',
  'agents.selectGroups': 'グループを選択',
  'agents.ticketVisibility': 'チケットの表示範囲',
  'agents.ticketVisibilityHelp': 'エージェントごとに狭い範囲を選択するか、ロールのデフォルトを継承します。エージェントが実行できる操作は引き続きロール権限で決まります。',
  'agents.scopeRoleDefault': 'ロールのデフォルトを使用',
  'agents.scopeRoleDefaultHelp': 'このロールに設定されたデフォルトの表示範囲を継承します。',
  'agents.scopeAll': 'すべてのチケット',
  'agents.scopeAllHelp': 'このアカウントの削除されていないすべてのチケットを表示します。',
  'agents.scopeGroup': 'グループ内のチケット',
  'agents.scopeGroupHelp': 'このエージェントが所属するグループに割り当てられたチケットを表示します。',
  'agents.scopeAssigned': '割り当て済みチケット',
  'agents.scopeAssignedHelp': 'このエージェントに直接割り当てられたチケットを表示します。',
  'agents.scopeCollaboratorHelp': 'コラボレーターは引き続き L1 グループのチケットに制限されます。',
  'nav.jira': 'Jira連携',
  'notifications.groupAssigned': 'グループへの割り当て',
  'notifications.groupMemberAdded': 'グループに追加されました',
  'preferences.groupAssignedEvent': 'チケットがあなたのグループのいずれかに割り当てられたとき',
  'preferences.groupMemberAddedEvent': 'サポートグループに追加されたとき',
  'ui.select': '選択…',
  'ui.any': 'すべて',
  'ui.typeToSearch': '入力して検索…',
  'ui.noResults': '結果が見つかりません',
  'ui.clearSelection': '選択を解除',
  'ui.removeItem': '{label}を削除',
  'ui.pressEnterToUse': 'Enterキーでこの値を使用',
  'ui.removeFilter': 'フィルターを削除 {field}: {value}',
  'ui.removeTag': 'タグ{label}を削除',
  'ui.retry': '再試行',
  'ui.errorTitle': 'このコンテンツを読み込めませんでした',
  'ui.errorMessage': '接続を確認して、もう一度お試しください。',
  'ui.reference': '参照: {id}',
  'ui.thisArea': 'この領域',
  'ui.noAccess': '{area}へのアクセス権がありません',
  'ui.noAccessHint': '必要な権限の付与を管理者に依頼してください。',
  'ui.actionFailed': 'この操作を完了できませんでした。もう一度お試しください。',
  'ui.slaPaused': 'SLA一時停止中',
  'ui.filteredEmptyTitle': 'これらのフィルターに一致するチケットはありません',
  'ui.filteredEmptyDescription': 'フィルターを外すか、日付範囲を広げてください。',
  'ui.clearFilters': 'フィルターをクリア',
  'pagination.noResults': '結果なし',
  'pagination.showing': '{total}件中 {first}–{last}件を表示',
  'pagination.resultsPerPage': '1ページあたりの件数',
  'pagination.perPage': '1ページ{count}件',
  'pagination.previous': '前へ',
  'pagination.next': '次へ',
  'pagination.previousAria': '前のページ',
  'pagination.nextAria': '次のページ',
  'pagination.pageOf': '{total}ページ中 {page}ページ目',
  'status.open': 'オープン',
  'status.to_be_prioritised': '優先度設定待ち',
  'status.work_in_progress': '作業中',
  'status.assigned_to_ai_agent': 'AIエージェントに割り当て済み',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': '保留中',
  'status.awaiting_user_reply': 'ユーザーの返信待ち',
  'status.awaiting_resolution_confirmation': '解決確認待ち',
  'status.on_hold': '保留',
  'status.pending_production_release': '本番リリース待ち',
  'status.product_cr': '製品CR',
  'status.reopened': '再オープン',
  'status.issue_fixed': '問題修正済み',
  'status.resolved': '解決済み',
  'status.closed': 'クローズ',
  'status.unknown': '不明',
  'priority.low': '低',
  'priority.medium': '中',
  'priority.high': '高',
  'priority.urgent': '緊急',
  'source.email': 'メール',
  'source.portal': 'ポータル',
  'source.phone': '電話',
  'source.chat': 'チャット',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Webチャット',
  'source.web_form': 'Webフォーム',
  'source.forum': 'フォーラム',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'フィードバックウィジェット',
  'source.outbound_email': '送信メール',
  'source.ecommerce': 'Eコマース',
  'source.bot': 'ボット',
  'source.instagram_message': 'Instagramメッセージ',
  'source.instagram_comment': 'Instagramコメント',
  'source.facebook_message': 'Facebookメッセージ',
  'source.facebook_comment': 'Facebookコメント',
  'source.mobile_chat_sdk': 'モバイルチャットSDK',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': '保存したビュー',
  'savedViews.saveCurrent': '現在のフィルターをビューとして保存',
  'savedViews.namePlaceholder': 'ビュー名...',
  'savedViews.nameAria': 'ビュー名',
  'savedViews.empty': '保存したビューはありません。フィルターを適用してここに保存してください。',
  'savedViews.listAria': '保存したビューの一覧',
  'savedViews.rename': 'ビュー「{name}」の名前を変更',
  'savedViews.delete': 'ビュー「{name}」を削除',
  'export.title': 'チケットをエクスポート',
  'export.loadError': 'エクスポート項目の一覧を読み込めませんでした。',
  'export.failed': 'エクスポートに失敗しました。もう一度お試しください。',
  'export.pdfFailed': 'PDFのエクスポートに失敗しました。もう一度お試しください。',
  'export.fieldsSelectedOne': '{count}項目を選択中',
  'export.fieldsSelectedMany': '{count}項目を選択中',
  'export.fieldsTotalOne': '全{count}項目',
  'export.fieldsTotalMany': '全{count}項目',
  'export.selectAllFields': 'すべての項目を選択',
  'export.exportingOne': '選択した1件のチケットをエクスポートしています。',
  'export.exportingMany': '選択した{count}件のチケットをエクスポートしています。',
  'export.pdfZip': 'PDFとしてダウンロード (.zip、{count}ファイル)',
  'export.pdf': 'PDFとしてダウンロード',
  'export.pdfZipHint': 'チケットごとにPDFを作成し、1つのZIPにまとめてダウンロードします。',
  'export.pdfHint': 'チケットのプロパティと公開会話スレッドを含む1つのPDFを作成します。',
  'export.formatLabel': 'エクスポート形式 (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': '項目一覧を読み込み中…',
  'export.ticketFields': 'チケット項目',
  'export.contactFields': '連絡先項目',
  'export.companyFields': '会社項目',
  'export.exporting': 'エクスポート中…',
  'newTicket.title': 'チケットを作成',
  'newTicket.description': '保存済みのフォームを選択し、項目を入力してください。',
  'newTicket.form': 'チケットフォーム',
  'newTicket.noForms': '利用可能なチケットフォームがありません。チケットを作成する前にフォームを設定してください。',
  'newTicket.loadFormsError': 'チケットフォームを読み込めませんでした',
  'newTicket.loadFormError': '選択したチケットフォームを読み込めませんでした',
  'newTicket.addCc': 'CCを追加',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': '{name}を削除',
  'newTicket.requesterRequired': '依頼者は必須です',
  'newTicket.subjectRequired': '件名は必須です',
  'newTicket.createFailed': 'チケットの作成に失敗しました',
  'newTicket.noFormTitle': '利用可能なチケットフォームがありません',
  'newTicket.noFormDescription': '設定でチケットフォームを作成してから、チケットを開いてください。',
  'newTicket.noFieldsTitle': 'このフォームにはまだ項目がありません',
  'newTicket.noFieldsDescription': '設定でフォームに項目を追加してから、このページを再読み込みしてください。',
  'newTicket.creating': '作成中...',
  'newTicket.submit': 'チケットを作成',
  'fields.required': '{label}は必須です',
  'fields.selectParentFirst': '先に親の値を選択してください...',
  'fields.selectPlaceholder': '{label}を選択...',
  'fields.enterPlaceholder': '{label}を入力...',
  'fields.optionsLoadError': '{label}の選択肢を読み込めませんでした',
  'fields.label.requester': '依頼者',
  'fields.label.subject': '件名',
  'fields.label.description': '説明',
  'fields.label.status': 'ステータス',
  'fields.label.priority': '優先度',
  'fields.label.source': 'ソース',
  'fields.label.ticket_type': 'タイプ',
  'fields.label.agent': '担当者',
  'fields.label.group': 'グループ',
  'fields.label.internal_agent': '内部担当者',
  'fields.label.internal_group': '内部グループ',
  'fields.label.company': '会社',
  'editor.defaultPlaceholder': 'ここに入力...',
  'editor.ariaLabel': 'リッチテキストエディター',
  'editor.toolbarAria': 'テキスト書式',
  'editor.bold': '太字 (Ctrl+B)',
  'editor.italic': '斜体 (Ctrl+I)',
  'editor.underline': '下線 (Ctrl+U)',
  'editor.strikethrough': '取り消し線',
  'editor.heading1': '見出し1',
  'editor.heading2': '見出し2',
  'editor.textColor': '文字色',
  'editor.highlight': 'ハイライト',
  'editor.bulletList': '箇条書き',
  'editor.numberedList': '番号付きリスト',
  'editor.blockquote': '引用',
  'editor.codeBlock': 'コードブロック',
  'editor.insertLink': 'リンクを挿入',
  'editor.insertImage': '画像を挿入',
  'editor.insertTable': '表を挿入',
  'editor.mention': 'メンションする',
  'editor.undo': '元に戻す (Ctrl+Z)',
  'editor.redo': 'やり直す (Ctrl+Shift+Z)',
  'editor.attach': 'ファイルを添付',
  'editor.noAgents': '担当者が見つかりません',
  'editor.mentionSuggestions': 'メンション候補',
  'editor.dialogLinkTitle': 'リンクを挿入',
  'editor.dialogImageTitle': '画像を挿入',
  'editor.linkHint': 'HTTP(S)、mailto、アンカー、または相対URLを入力してください。',
  'editor.imageHint': 'HTTP(S)または相対の画像URLを入力してください。',
  'editor.url': 'URL',
  'editor.invalidLink': '有効なHTTP(S)、mailto、アンカー、または相対URLを入力してください。',
  'editor.invalidImage': '有効なHTTP(S)または相対の画像URLを入力してください。',
  'editor.selectTextForLink': 'リンクを追加する前にテキストを選択してください。',
  'editor.imageInsertFailed': 'ここに画像を挿入できませんでした。',
  'editor.insertLinkAction': 'リンクを挿入',
  'editor.insertImageAction': '画像を挿入',
  'search.dialogAria': 'グローバル検索',
  'search.placeholder': 'チケット、連絡先を検索...',
  'search.aria': '検索',
  'search.close': '検索を閉じる',
  'search.noMatches': '「{query}」に一致する結果はありません',
  'search.noMatchesHint': 'チケット番号、連絡先のメールアドレス、会社名をお試しください。',
  'search.hintBefore': '2文字以上入力して検索します。閉じるには',
  'search.hintAfter': 'を押します。',

  'td.system': 'システム',
  'td.actionCreatedTicket': 'がチケットを作成しました',
  'td.actionUpdatedFields': 'が{fields}を更新しました',
  'td.fieldStatus': 'ステータス',
  'td.fieldPriority': '優先度',
  'td.fieldSource': 'ソース',
  'td.fieldType': 'タイプ',
  'td.fieldGroup': 'グループ',
  'td.fieldAgent': 'エージェント',
  'td.fieldCompany': '会社',
  'td.fieldContact': '連絡先',
  'td.fieldSubject': '件名',
  'td.fieldDescription': '説明',
  'td.fieldProduct': '製品',
  'td.fieldResolutionDue': '解決期限',
  'td.fieldFirstResponseDue': '初回応答期限',
  'td.fieldTags': 'タグ',
  'td.fieldParentTicket': '親チケット',
  'td.eventCreated': '{actor}が新しいチケットを作成しました',
  'td.eventCreatedLinked': '{actor}が新しいチケットを作成し、親チケットにリンクしました',
  'td.eventSplit': '{actor}がこのチケットを分割し、子チケット{ref}を作成しました',
  'td.eventMergeReceived': '{actor}が別のチケットをこのチケットに統合しました{ref}',
  'td.eventMerged': '{actor}がこのチケットを別のチケットに統合しました{ref}',
  'td.eventSplitCopied': '{actor}が{conversations}と{attachments}をコピーしました',
  'td.conversationsOne': '{count}件の会話',
  'td.conversationsMany': '{count}件の会話',
  'td.attachmentsOne': '{count}件の添付ファイル',
  'td.attachmentsMany': '{count}件の添付ファイル',
  'td.eventUpdatedFields': '{actor}が{fields}を更新しました',
  'td.invalidSlaState': 'サーバーから無効なSLA状態が返されました。',
  'td.slaRefreshError': 'SLAクロックを更新できません。',
  'td.descriptionUpdated': '説明を更新しました',
  'td.descriptionUpdateError': '説明を更新できません',
  'td.descriptionUpdateFailed': '説明の更新に失敗しました',
  'td.entryUpdated': 'エントリを更新しました',
  'td.entryUpdateError': 'エントリを更新できません',
  'td.updateFailed': '更新に失敗しました',
  'td.loadOlderError': '以前の会話を読み込めません',
  'td.loadFailed': '読み込みに失敗しました',
  'td.slaUpdateFailed': 'SLAの更新に失敗しました',
  'td.reasonTooLong': '理由は500文字以内で入力してください。',
  'td.invalidDateTime': '有効な日時を選択してください。',
  'td.slaDeadlineUpdated': 'SLA期限を更新しました',
  'td.slaConflict': 'SLAデータの編集中にチケットが変更されました。再読み込みしてからもう一度お試しください。',
  'td.slaClearFailed': 'SLAのクリアに失敗しました',
  'td.slaTargetCleared': 'SLA目標をクリアしました',
  'td.slaClearError': 'SLA目標をクリアできません',
  'td.noDescription': '説明はまだ追加されていません。',
  'td.editDescriptionAria': 'チケットの説明を編集',
  'td.download': 'ダウンロード',
  'td.downloadFile': '{fileName}をダウンロード',
  'td.loadOlder': '↓ +{count}件の会話',
  'td.loadOlderMany': '↓ +{count}件の会話',
  'td.edited': '(編集済み)',
  'td.privateThread': 'プライベートスレッド',
  'td.propertiesAria': 'チケットのプロパティ',
  'td.expandProperties': 'プロパティを展開',
  'td.collapseProperties': 'プロパティを折りたたむ',
  'td.metric': '指標',
  'td.firstResponseOption': '初回応答',
  'td.resolutionOption': '解決',
  'td.overrideHint': 'サーバー側で有効な期限の上書きを設定します。理由はSLA履歴に保存されます。',
  'td.deadline': '期限',
  'td.reasonOptional': '理由（任意）',
  'td.reasonPlaceholder': '承認済みの例外または運用上の背景',
  'td.clearResolutionOverride': '解決の上書きをクリア',
  'td.clearEscalationTarget': 'エスカレーション目標をクリア',
  'td.toolsAria': 'チケットツールと連絡先',
  'td.ticketContext': 'チケットのコンテキスト',
  'td.knowledgeBase': 'ナレッジベース',
  'td.shortcutsAria': 'チケットコンテキストのショートカット',
  'td.showContext': 'チケットのコンテキストを表示',
  'td.hideContext': 'チケットのコンテキストを非表示',
  'td.openRow': '{label}を開く',
  'td.editTicket': 'チケットを編集',
  'td.searchContactPlaceholder': '連絡先を検索…',
  'td.describePlaceholder': '問題の内容を入力…',
  'td.noAttachments': '添付ファイルなし',

  'tp.api.csrfUnavailable': 'CSRF保護を確立できません',
  'tp.api.noMfaChallenge': '有効なMFAチャレンジがありません',
  'tp.api.noMfaSetup': '有効なMFA設定チャレンジがありません',
  'tp.api.noNewPasswordChallenge': '有効な新しいパスワードのチャレンジがありません',
  'tp.articles.isLinkedAria': '{title}は解決策としてリンクされています',
  'tp.articles.linkAria': '{title}を解決策としてリンク',
  'tp.articles.linkAsSolution': '解決策としてリンク',
  'tp.articles.linkedAsSolution': '解決策としてリンク済み',
  'tp.articles.none': 'このチケットに推奨記事はありません。',
  'tp.articles.title': '推奨記事',
  'tp.articles.views': '{count}回表示',
  'tp.attachment.loadingPreview': 'プレビューを読み込み中…',
  'tp.attachment.previewUnavailable': 'プレビューは利用できません',
  'tp.charts.noData': 'この期間のグラフデータはありません。',
  'tp.charts.noRecords': 'この期間のレコードはありません。',
  'tp.charts.period': '期間',
  'tp.charts.showingTop': '{total}件のセグメントのうち上位{shown}件を表示しています。',
  'tp.common.cancel': 'キャンセル',
  'tp.common.clear': 'クリア',
  'tp.common.loading': '読み込み中…',
  'tp.common.send': '送信',
  'tp.common.sending': '送信中…',
  'tp.common.system': 'システム',
  'tp.convActions.edit': '編集',
  'tp.convActions.thread': 'スレッドを開始',
  'tp.dashboard.new': '新規',
  'tp.dashboard.select': 'ダッシュボードを選択',
  'tp.forward.failed': '転送に失敗しました',
  'tp.forward.forwarded': 'チケットを転送しました',
  'tp.forward.forwarding': '転送中…',
  'tp.forward.forwardingMany': '{count}件の会話を転送中:',
  'tp.forward.forwardingOne': '1件の会話を転送中:',
  'tp.forward.message': 'メッセージ',
  'tp.forward.messagePlaceholder': 'メッセージを追加（任意）…',
  'tp.forward.noContacts': '連絡先が見つかりません — 完全なメールアドレスを入力してください',
  'tp.forward.recipientEmail': '宛先メールアドレス',
  'tp.forward.recipientInvalid': '有効な宛先メールアドレスを入力してください',
  'tp.forward.recipientRequired': '宛先メールアドレスは必須です',
  'tp.forward.searchContact': '連絡先を検索、またはメールアドレスを入力…',
  'tp.forward.title': '転送',
  'tp.forward.to': '宛先',
  'tp.forward.useThisEmail': 'Enterキーを押すか「転送」をクリックしてこのメールアドレスを使用',
  'tp.jira.addOptional': '任意項目を追加',
  'tp.jira.createAndLink': '課題を作成してリンク',
  'tp.jira.createIssue': '課題を作成',
  'tp.jira.createTitle': 'Jira課題を作成',
  'tp.jira.describePlaceholder': '問題の内容を入力…',
  'tp.jira.description': '説明',
  'tp.jira.development': '開発',
  'tp.jira.enterDevelopment': '開発を入力',
  'tp.jira.hideOptional': '任意項目を非表示',
  'tp.jira.issueId': '課題ID',
  'tp.jira.issueSummary': '課題の概要',
  'tp.jira.issueType': '課題タイプ *',
  'tp.jira.lastSync': '最終同期: {error}',
  'tp.jira.linkIssue': '課題をリンク',
  'tp.jira.linkTitle': 'Jira課題をリンク',
  'tp.jira.linkedIssues': 'リンクされた課題',
  'tp.jira.linkedIssuesHint': 'Jira課題キーをカンマで区切って入力してください。',
  'tp.jira.linkedIssuesPlaceholder': '例: SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Jiraフィールドを読み込み中…',
  'tp.jira.loadingIssueTypes': '課題タイプを読み込み中…',
  'tp.jira.loadingProjects': 'Jiraプロジェクトを読み込み中…',
  'tp.jira.loadingUsers': 'Jiraユーザーを読み込み中…',
  'tp.jira.noLinks': 'このチケットにリンクされたJira課題はまだありません。',
  'tp.jira.noneFound': 'Jira課題が見つかりません。',
  'tp.jira.notAvailableProject': 'このプロジェクトでは利用できません',
  'tp.jira.projects': 'プロジェクト *',
  'tp.jira.refresh': '更新',
  'tp.jira.refreshFields': 'Jiraフィールドを更新',
  'tp.jira.reporter': '報告者',
  'tp.jira.requestFailed': 'Jiraリクエストに失敗しました。再度お試しください。',
  'tp.jira.searchBy': '検索条件:',
  'tp.jira.searchIssue': '課題を検索',
  'tp.jira.searchIssuePlaceholder': '課題を検索…',
  'tp.jira.searchUsers': 'Jiraユーザーを検索',
  'tp.jira.searching': 'Jiraを検索中…',
  'tp.jira.selectIssueType': '課題タイプを選択',
  'tp.jira.selectProject': 'プロジェクトを選択',
  'tp.jira.summary': '概要 *',
  'tp.jira.syncOff': '同期オフ',
  'tp.jira.syncOn': '同期オン',
  'tp.jira.syncStatus': 'チケットのステータスをJiraに同期',
  'tp.jira.unassigned': '未割り当て',
  'tp.jira.unlink': 'リンク解除',
  'tp.jira.unlinkConfirm': '課題のリンクを解除',
  'tp.jira.unlinkDescription': 'チケットとの関連付けは削除されますが、Jira課題は削除されません。',
  'tp.jira.unlinkTitle': '{key}のリンクを解除しますか？',
  'tp.jira.untitled': '無題のJira課題',
  'tp.layout.loadingPage': 'ページを読み込み中…',
  'tp.notFound.goToDashboard': 'ダッシュボードへ移動',
  'tp.notFound.title': 'ページが見つかりません',
  'tp.portal.brand': 'SuzukiDesk サポート',
  'tp.portal.customer': 'お客様',
  'tp.reply.addNote': 'メモを追加',
  'tp.reply.attachmentNotAdded': '添付ファイルは追加されませんでした',
  'tp.reply.clickToExpand': 'クリックして展開',
  'tp.reply.collapsedNote': '社内メモを追加…',
  'tp.reply.collapsedReply': '返信またはメモを入力…',
  'tp.reply.conversationType': '会話タイプ',
  'tp.reply.failedToSend': '送信に失敗しました',
  'tp.reply.markNoteAs': 'メモの種類',
  'tp.reply.notVisibleToContact': '連絡先には表示されません',
  'tp.reply.notVisibleToContacts': '連絡先には表示されません',
  'tp.reply.noteAdded': 'メモを追加しました',
  'tp.reply.notifyTo': '通知先',
  'tp.reply.placeholderPrivateNote': 'プライベートメモを追加...',
  'tp.reply.placeholderPublicNote': '依頼者に表示される公開メモを追加...',
  'tp.reply.placeholderReply': '返信を入力...',
  'tp.reply.private': 'プライベート',
  'tp.reply.public': '公開',
  'tp.reply.removeFile': '{name}を削除',
  'tp.reply.replySent': '返信を送信しました',
  'tp.reply.searchAgentsToNotify': '通知するエージェントを検索…',
  'tp.reply.sendReply': '返信を送信',
  'tp.reply.sending': '送信中...',
  'tp.reply.tabNote': 'メモ',
  'tp.reply.tabReply': '返信',
  'tp.reply.uploadAttachment': '添付ファイルをアップロード',
  'tp.reply.visibleToContact': '連絡先に表示されます',
  'tp.reply.visibleToContacts': '連絡先に表示されます',
  'tp.sla.breached': '違反',
  'tp.sla.cleared': 'クリア済み',
  'tp.sla.configErrorNoDeadline': 'SLA設定エラー。期限は推定されません。',
  'tp.sla.configurationError': '設定エラー',
  'tp.sla.couldNotLoad': 'SLAクロックを読み込めませんでした',
  'tp.sla.done': '完了',
  'tp.sla.dueIn': '{duration}後に期限',
  'tp.sla.dueLine': '期限: {date}',
  'tp.sla.dueNow': '今すぐ期限',
  'tp.sla.escalated': 'エスカレーション済み',
  'tp.sla.firstResponse': '初回応答',
  'tp.sla.invalidDeadline': '無効な期限',
  'tp.sla.mayBeStale': 'SLAクロックが古い可能性があります',
  'tp.sla.noActiveCycle': '有効なSLAサイクルはありません。',
  'tp.sla.noDeadline': '期限なし',
  'tp.sla.noMetrics': 'このサイクルで利用できるSLA指標はありません。',
  'tp.sla.noPolicy': 'このチケットにはSLAポリシーが適用されていません。',
  'tp.sla.notConfigured': '未設定',
  'tp.sla.notStarted': '未開始',
  'tp.sla.overdueBy': '{duration}期限超過',
  'tp.sla.overridden': '上書き済み',
  'tp.sla.overrideReason': '上書きの理由: {reason}',
  'tp.sla.paused': '一時停止中',
  'tp.sla.refreshing': '正式なSLAクロックを更新中…',
  'tp.sla.resolution': '解決',
  'tp.sla.stopsSla': 'SLAを停止',
  'tp.thread.empty': 'まだ何も送信されていません。最初のメッセージでこのプライベートスレッドが始まります。',
  'tp.thread.messageFailed': 'メッセージの送信に失敗しました',
  'tp.thread.privateThread': 'プライベートスレッド',
  'tp.thread.replyPlaceholder': 'スレッドに返信…',
  'tp.thread.someone': '誰か',
  'tp.thread.startPrivateThread': 'プライベートスレッドを開始',
  'tp.thread.startedBy': '{name}がこのスレッドを開始しました',
  'tp.thread.unableToSend': 'メッセージを送信できません',
  'tp.ui.breadcrumb': 'パンくずリスト',
  'tp.ui.closePanel': 'パネルを閉じる',
  'tp.ui.dismiss': '{title}を閉じる',

  'dir.loadError': 'データを読み込めません。再度お試しください。',
  'dir.contacts.description': 'お客様の連絡先とサポート履歴。',
  'dir.contacts.searchAria': '連絡先を検索',
  'dir.contacts.count': '{count}件の連絡先',
  'dir.contacts.noMatch': 'この検索に一致する連絡先はありません',
  'dir.contacts.none': '連絡先はまだありません',
  'dir.contacts.noneDescription': 'お客様がチケットを送信し始めると、連絡先がここに表示されます。',
  'dir.company': '会社',
  'dir.unnamedContact': '名前のない連絡先',
  'dir.contact': '連絡先',
  'dir.contactNotFound': '連絡先が見つかりません。',
  'dir.confirmDeleteContactTitle': '「{name}」を削除しますか？',
  'dir.thisContact': 'この連絡先',
  'dir.confirmDeleteContactDescription': 'チケットのある連絡先は、完全に削除されず無効化されます。',
  'dir.deleteContact': '連絡先を削除',
  'dir.editProfile': 'プロフィールを編集',
  'dir.profile': 'プロフィール',
  'dir.firstName': '名',
  'dir.lastName': '姓',
  'dir.phone': '電話番号',
  'dir.timezone': 'タイムゾーン',
  'dir.emailLabel': 'メール:',
  'dir.phoneLabel': '電話番号:',
  'dir.companyLabel': '会社:',
  'dir.timezoneLabel': 'タイムゾーン:',
  'dir.recentTickets': '最近のチケット',
  'dir.noTicketsYet': 'チケットはまだありません',
  'dir.contactTicketsDescription': 'この連絡先が起票したチケットがここに一覧表示されます。',
  'dir.ticket': 'チケット',
  'dir.subject': '件名',
  'dir.status': 'ステータス',
  'dir.created': '作成日',
  'dir.companies.description': '顧客の連絡先やチケットに関連付けられた組織。',
  'dir.companies.add': '会社を追加',
  'dir.companies.domain': 'ドメイン',
  'dir.companies.create': '会社を作成',
  'dir.companies.searchAria': '会社を検索',
  'dir.companies.searchPlaceholder': '会社またはドメインを検索',
  'dir.companies.noMatch': 'この検索に一致する会社はありません',
  'dir.companies.addFirst': '最初の会社を追加',
  'dir.companies.tryDifferent': '別の会社名またはドメインをお試しください。',
  'dir.companies.useForm': 'この一覧の横にあるフォームで会社を作成してください。',
  'dir.companies.contacts': '連絡先',
  'dir.companies.tickets': 'チケット',
  'dir.companies.notFound': '会社が見つかりません。',
  'dir.companies.confirmDeleteTitle': '「{name}」を削除しますか？',
  'dir.companies.thisCompany': 'この会社',
  'dir.companies.confirmDeleteDescription': '会社を削除するには、連絡先とチケットがない状態である必要があります。',
  'dir.companies.delete': '会社を削除',
  'dir.companies.noDomain': 'ドメインが設定されていません',
  'dir.companies.contactsCount': '連絡先 ({count})',
  'dir.companies.ticketsCount': 'チケット ({count})',
  'dir.companies.noContactsDescription': '連絡先を追加してこの会社にリンクすると、ここに表示されます。',
  'dir.companies.noTicketsDescription': 'この会社の連絡先が起票したチケットがここに一覧表示されます。',
  'dir.trendsCreatedHour': '作成日 - 時間帯',
  'dir.reports.loadError': 'このレポートを読み込めません。再度お試しください。',
  'dir.reports.volume': 'チケット件数',
  'dir.reports.sla': 'SLA達成率',
  'dir.reports.agents': 'エージェントのパフォーマンス',
  'dir.reports.csat': '顧客満足度',
  'dir.reports.rca': '根本原因分析',
  'dir.reports.descVolume': 'チケットの発生元とライフサイクルでの推移を確認できます。',
  'dir.reports.descSla': 'アクセス可能なサポート業務全体の応答・解決目標を追跡します。',
  'dir.reports.descAgents': 'エージェントごとの作業量、成果、返信数、平均対応時間を比較します。',
  'dir.reports.descCsat': '応答件数と満足度を混同せずに、顧客の評価を確認できます。',
  'dir.reports.descRca': 'チケット発生の背景にある標準化された根本原因を調べます。',
  'dir.reports.noPayload': 'この期間のレポートデータは返されませんでした。',
  'dir.reports.refresh': '更新',
  'dir.reports.report': 'レポート',
  'dir.reports.from': '開始',
  'dir.reports.to': '終了',
  'dir.reports.maxRange': '最大範囲: 90日 · 対象範囲はアカウントの権限に従います。',
  'dir.reports.unclassified': '未分類',
  'dir.reports.ticketsInPeriod': '期間内のチケット',
  'dir.reports.ticketsInPeriodDetail': 'レポートで返されたアクセス可能なチケット',
  'dir.reports.created': '作成',
  'dir.reports.createdDetail': '選択した日付軸全体',
  'dir.reports.resolved': '解決',
  'dir.reports.resolvedDetail': '作成件数の{percent}%',
  'dir.reports.noCreated': '作成されたチケットはありません',
  'dir.reports.reopened': '再オープン',
  'dir.reports.reopenedDetail': 'ライフサイクルイベント（重複なしのチケット数ではありません）',
  'dir.reports.dailyPulse': '日次の動向',
  'dir.reports.volumeByDate': '日付別チケット件数',
  'dir.reports.volumeByDateDescription': 'バックエンドの疎な行を、ゼロ埋めされた完全な日付軸に展開しています。',
  'dir.reports.createdTickets': '作成されたチケット',
  'dir.reports.createdVolumeAria': '日付別の作成チケット件数',
  'dir.reports.lifecycle': 'ライフサイクル',
  'dir.reports.lifecycleTitle': '作成、解決、再オープン',
  'dir.reports.lifecycleDescription': 'チケットライフサイクルでの推移を3本の線で表示します。',
  'dir.reports.lifecycleAria': '日付別のチケットライフサイクルイベント',
  'dir.reports.dimensions': 'ディメンション',
  'dir.reports.whereConcentrated': '件数が集中している箇所',
  'dir.reports.topEight': '各パネルに上位8セグメントを表示',
  'dir.reports.status': 'ステータス',
  'dir.reports.statusDescription': '現在のチケットステータス',
  'dir.reports.priority': '優先度',
  'dir.reports.priorityDescription': 'チケット優先度の内訳',
  'dir.reports.group': 'グループ',
  'dir.reports.groupDescription': 'ルーティンググループ',
  'dir.reports.agent': 'エージェント',
  'dir.reports.agentDescription': '割り当て担当',
  'dir.reports.product': '製品',
  'dir.reports.productDescription': '製品の内訳',
  'dir.reports.country': '国',
  'dir.reports.countryDescription': '標準化された国フィールドより',
  'dir.reports.noRecords': 'この期間のレコードはありません。',
  'dir.reports.slaSummary': '{rate} · {total}件中{met}件達成',
  'dir.reports.noSlaSegments': 'SLAセグメントはまだありません',
  'dir.reports.noSlaSegmentsDescription': '選択した期間に、このディメンションに該当するSLAレコードはありません。',
  'dir.reports.segment': 'セグメント',
  'dir.reports.firstResponse': '初回応答',
  'dir.reports.resolution': '解決',
  'dir.reports.avgFirstResponse': '平均初回応答',
  'dir.reports.avgResolution': '平均解決時間',
  'dir.reports.fromTicketMetric': 'TicketMetricより',
  'dir.reports.slaLens': 'SLAビュー',
  'dir.reports.performanceBySegment': 'セグメント別パフォーマンス',
  'dir.reports.slaRatesNote': '達成率は、該当するSLA目標があるレコードのみで算出します。所要時間は平均経過時間です。',
  'dir.reports.slaDimensionAria': 'SLA内訳のディメンション',
  'dir.reports.rosterSignal': '担当体制の指標',
  'dir.reports.agentPerformance': 'エージェントのパフォーマンス',
  'dir.reports.agentPerformanceDescription': '稼働のないエージェントを含め、有効なすべてのエージェントが対象です。',
  'dir.reports.filterAgentsAria': 'エージェントを絞り込み',
  'dir.reports.filterAgentsPlaceholder': 'エージェントまたはメールで絞り込み',
  'dir.reports.matchingAgents': '一致するエージェント: {count}名',
  'dir.reports.activeAgents': '有効なエージェント: {count}名',
  'dir.reports.sortedBy': '{key}の{direction}で並べ替え',
  'dir.reports.asc': '昇順',
  'dir.reports.desc': '降順',
  'dir.reports.noAgentsMatch': 'このフィルターに一致するエージェントはいません',
  'dir.reports.assigned': '割り当て済み',
  'dir.reports.replies': '返信',
  'dir.reports.csatScore': 'CSATスコア',
  'dir.reports.csatScoreDetail': '評価4または5',
  'dir.reports.averageRating': '平均評価',
  'dir.reports.averageRatingDetail': '評価済みアンケート全体',
  'dir.reports.ratedSurveys': '評価済みアンケート',
  'dir.reports.ratedSurveysDetail': '選択した期間内',
  'dir.reports.satisfied': '満足',
  'dir.reports.satisfiedDetail': '肯定的な回答',
  'dir.reports.responseTrend': '回答の推移',
  'dir.reports.surveyVolume': '日付別アンケート件数',
  'dir.reports.surveyVolumeDescription': 'バックエンドは日付ごとの回答件数を返します。日次スコアではありません。以下では直近100件の回答をサンプル表示しています。',
  'dir.reports.surveyResponses': 'アンケート回答',
  'dir.reports.surveyVolumeAria': '日付別のCSATアンケート回答件数',
  'dir.reports.responsesByGroup': 'グループ別の回答数',
  'dir.reports.responsesByGroupDescription': 'アンケート回答数であり、グループの満足度ではありません',
  'dir.reports.responsesByAgent': 'エージェント別の回答数',
  'dir.reports.responsesByAgentDescription': 'アンケート回答数であり、エージェントの満足度ではありません',
  'dir.reports.customerVoice': 'お客様の声',
  'dir.reports.latestSurveys': '最新のアンケート回答',
  'dir.reports.boundedSample': '上限付きサンプル · 最大100件中{count}件',
  'dir.reports.latestSurveysNote': 'レポートAPIが返した最新の回答です。この表は簡易確認用で、完全なエクスポートではありません。',
  'dir.reports.noSurveys': 'アンケート回答はありません',
  'dir.reports.noSurveysDescription': 'お客様が解決済みチケットを評価すると、CSAT回答がここに表示されます。',
  'dir.reports.rating': '評価',
  'dir.reports.comment': 'コメント',
  'dir.reports.received': '受信日時',
  'dir.reports.ratingOutOf': '5段階中{rating}',
  'dir.reports.noComment': 'コメントなし',
  'dir.reports.rcaEyebrow': '根本原因分析',
  'dir.reports.rcaTitle': 'チケットが起票される理由',
  'dir.reports.rcaDescription': 'カテゴリとサブカテゴリは、標準化されたチケットのカスタムフィールドから独立して集計されます。',
  'dir.reports.rcaDimensionAria': 'RCAのディメンション',
  'dir.reports.category': 'カテゴリ',
  'dir.reports.subcategory': 'サブカテゴリ',
  'dir.reports.rcaEmpty': 'この期間に記録された根本原因の値はありません。',
  'dir.kb.articleLoadError': '記事を読み込めません。',
  'dir.kb.articleNotFound': '記事が見つかりません。',
  'dir.kb.retry': '再試行',
  'dir.kb.title': 'ナレッジベース',
  'dir.kb.breadcrumb': 'ナレッジベース',
  'dir.kb.description': '{folders}個のフォルダーに{articles}件の記事',
  'dir.kb.newArticle': '新しい記事',
  'dir.kb.editArticle': '記事を編集',
  'dir.kb.sectionsAria': 'ナレッジベースのセクション',
  'dir.kb.tabArticles': '記事',
  'dir.kb.tabStructure': 'カテゴリとフォルダー',
  'dir.kb.folderFilterAria': 'フォルダーフィルター',
  'dir.kb.allArticles': 'すべての記事 ({count})',
  'dir.kb.writeFirst': '最初の記事を書く',
  'dir.kb.writeFirstDescription': '「新しい記事」を使ってこのフォルダーにコンテンツを追加します。',
  'dir.kb.byAuthor': '作成者: {name}',
  'dir.kb.views': '{count}回表示',
  'dir.kb.published': '公開済み',
  'dir.kb.draft': '下書き',
  'dir.kb.publish': '公開',
  'dir.kb.unpublish': '非公開にする',
  'dir.kb.noFolders': 'このカテゴリにフォルダーはありません',
  'dir.kb.noFoldersDescription': 'フォルダーを追加して記事のグループ化を始めましょう。',
  'dir.kb.articlesCount': '{count}件の記事',
  'dir.kb.fieldTitle': 'タイトル',
  'dir.kb.folder': 'フォルダー',
  'dir.kb.selectFolder': 'フォルダーを選択',
  'dir.kb.content': '内容',
  'dir.kb.contentPlaceholder': '記事の内容を入力...',
  'dir.kb.tags': 'タグ（カンマ区切り）',
  'dir.kb.attachments': '添付ファイル',
  'dir.kb.download': 'ダウンロード',
  'dir.kb.downloadFile': '{name}をダウンロード',
  'dir.kb.remove': '削除',
  'dir.kb.removeFile': '{name}を削除',
  'dir.kb.noAttachments': '添付ファイルはまだありません。',
  'dir.kb.uploadAria': '添付ファイルをアップロード',
  'dir.kb.uploading': 'アップロード中...',
  'dir.kb.addFile': 'ファイルを追加',
  'dir.kb.confirmDeleteTitle': '記事を削除しますか？',
  'dir.kb.confirmDeleteDescription': 'この公開済みまたは下書きの記事は完全に削除されます。',
  'dir.kb.confirmDeleteLabel': '記事を削除',
  'dir.kb.confirmRemoveTitle': '添付ファイルを削除しますか？',
  'dir.kb.confirmRemoveDescription': 'このファイルは記事から完全に削除されます。',
  'dir.kb.confirmRemoveLabel': '添付ファイルを削除',
  'dir.reports.rangeInvalid': '有効な開始日と終了日を選択してください。',
  'dir.reports.rangeOrder': '終了日は開始日以降にしてください。',
  'dir.reports.rangeMax': 'レポートの日付範囲は最大90日です。',

  'adm.active': '有効',
  'adm.auto.action.add_tag': 'タグを追加',
  'adm.auto.action.assign_agent': 'エージェントを割り当て',
  'adm.auto.action.assign_group': 'グループを割り当て',
  'adm.auto.action.send_email': 'メールを送信',
  'adm.auto.action.send_notification': '通知を送信',
  'adm.auto.action.set_priority': '優先度を設定',
  'adm.auto.action.set_status': 'ステータスを設定',
  'adm.auto.actions': 'アクション',
  'adm.auto.addAction': '+ アクションを追加',
  'adm.auto.addCondition': '+ 条件を追加',
  'adm.auto.addRule': 'ルールを追加',
  'adm.auto.colApplied': '適用されたアクション',
  'adm.auto.colDate': '日付',
  'adm.auto.colMatched': '一致',
  'adm.auto.colSubject': '件名',
  'adm.auto.colTicket': 'チケット',
  'adm.auto.conditions': '条件',
  'adm.auto.confirmDesc': 'このルールはただちに実行が停止され、復元できません。',
  'adm.auto.confirmLabel': 'ルールを削除',
  'adm.auto.confirmTitle': '自動化ルールを削除しますか？',
  'adm.auto.countMany': '{count}件の自動化ルール',
  'adm.auto.countOne': '{count}件の自動化ルール',
  'adm.auto.create': '作成',
  'adm.auto.createFirst': '最初の自動化ルールを作成',
  'adm.auto.createFirstDesc': '「ルールを追加」で、振り分け、優先度設定、通知を自動化できます。',
  'adm.auto.deleteFailed': '削除に失敗しました',
  'adm.auto.description': 'ルールは位置の順に順次実行されます。ルール内の条件はAND条件で評価されます。',
  'adm.auto.editRule': '自動化ルールを編集',
  'adm.auto.execFailed': '実行履歴を読み込めませんでした',
  'adm.auto.field.assigneeId': '担当者',
  'adm.auto.field.companyId': '会社',
  'adm.auto.field.groupId': 'グループ',
  'adm.auto.field.priority': '優先度',
  'adm.auto.field.requesterId': '依頼者',
  'adm.auto.field.source': 'ソース',
  'adm.auto.field.status': 'ステータス',
  'adm.auto.field.subject': '件名',
  'adm.auto.field.ticketTypeId': 'チケットタイプ',
  'adm.auto.hits': 'ヒット数',
  'adm.auto.loadFailed': '自動化ルールを読み込めませんでした',
  'adm.auto.log': 'ログ',
  'adm.auto.logTitle': '実行ログ — {name}',
  'adm.auto.moveDown': '下へ移動',
  'adm.auto.moveUp': '上へ移動',
  'adm.auto.newRule': '新しい自動化ルール',
  'adm.auto.no': 'いいえ',
  'adm.auto.noRuns': '実行記録はまだありません',
  'adm.auto.noRunsDesc': 'このルールが最初にチケットに一致すると、実行履歴がここに表示されます。',
  'adm.auto.op.contains': '含む',
  'adm.auto.op.ends_with': 'で終わる',
  'adm.auto.op.greater_than': 'より大きい',
  'adm.auto.op.in': 'のいずれか',
  'adm.auto.op.is': 'である',
  'adm.auto.op.is_empty': '空である',
  'adm.auto.op.is_not': 'でない',
  'adm.auto.op.is_not_empty': '空でない',
  'adm.auto.op.less_than': 'より小さい',
  'adm.auto.op.not_contains': '含まない',
  'adm.auto.op.not_in': 'のいずれでもない',
  'adm.auto.op.starts_with': 'で始まる',
  'adm.auto.reorderFailed': '並べ替えに失敗しました',
  'adm.auto.saveFailed': '保存に失敗しました',
  'adm.auto.stopProcessing': '以降のルールの処理を停止',
  'adm.auto.title': '自動化ルール',
  'adm.auto.toggleFailed': '切り替えに失敗しました',
  'adm.auto.trigger': 'トリガー *',
  'adm.auto.trigger.ticket_creation': 'チケット作成',
  'adm.auto.trigger.ticket_update': 'チケット更新',
  'adm.auto.trigger.time_trigger': '時間ベース',
  'adm.auto.triggerCol': 'トリガー',
  'adm.auto.valuePlaceholder': '値',
  'adm.auto.yes': 'はい',
  'adm.close': '閉じる',
  'adm.deleting': '削除中...',
  'adm.description': '説明',
  'adm.descriptionLabel': '説明',
  'adm.edit': '編集',
  'adm.email.addChannel': 'チャネルを追加',
  'adm.email.addTitle': 'メールチャネルを追加',
  'adm.email.colEmail': 'メール',
  'adm.email.colReplyTo': '返信先',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'このチャネルはサポートメールに使用できなくなります。',
  'adm.email.confirmLabel': 'チャネルを削除',
  'adm.email.confirmTitle': 'メールチャネルを削除しますか？',
  'adm.email.countMany': '{count}件のメールチャネル',
  'adm.email.countOne': '{count}件のメールチャネル',
  'adm.email.create': '作成',
  'adm.email.createFirst': '最初のメールチャネルを追加',
  'adm.email.createFirstDesc': '「チャネルを追加」でサポート用アドレスを接続すると、返信がこのデスクに届きます。',
  'adm.email.default': 'デフォルト',
  'adm.email.defaultChannel': 'デフォルトチャネル',
  'adm.email.deleteFailed': '削除に失敗しました',
  'adm.email.description': '受信・送信メールアドレス、SMTP設定、返信先設定を管理します。',
  'adm.email.editTitle': 'メールチャネルを編集',
  'adm.email.emailAddress': 'メールアドレス *',
  'adm.email.loadFailed': 'メール設定を読み込めませんでした',
  'adm.email.outbound': '送信SMTP',
  'adm.email.replyTo': '返信先アドレス',
  'adm.email.replyToPh': '（未入力の場合はメールアドレス）',
  'adm.email.saveFailed': '保存に失敗しました',
  'adm.email.sesGlobal': 'SES（グローバル）',
  'adm.email.smtpHost': 'SMTPホスト',
  'adm.email.smtpHostPh': '例: email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'SMTPパスワード',
  'adm.email.smtpPort': 'SMTPポート',
  'adm.email.smtpUser': 'SMTPユーザー',
  'adm.email.title': 'メールチャネル',
  'adm.groups.aboutBody': 'メンバーによって、既定でどのエージェントがこのグループのチケットを閲覧できるかが決まります。営業時間はここに振り分けられたチケットのSLA計測を管理し、チケットがSLAに違反した場合は担当者に加えてエスカレーション先にも通知されます。',
  'adm.groups.aboutTitle': 'このグループについて',
  'adm.groups.accountDefault': 'アカウントの既定',
  'adm.groups.activeAgentMany': '有効なエージェント: {count}名',
  'adm.groups.activeAgentOne': '有効なエージェント: {count}名',
  'adm.groups.activeAgents': '有効なエージェント',
  'adm.groups.addMember': 'メンバーを追加',
  'adm.groups.assignment': '割り当て',
  'adm.groups.autoAssign': '自動割り当て',
  'adm.groups.autoAssignNote': 'この製品ではチケットの割り当ては常に手動です。ラウンドロビンや負荷ベースの振り分けはありません。このトグルでその動作は変わりません。',
  'adm.groups.businessHours': '営業時間',
  'adm.groups.colGroup': 'グループ',
  'adm.groups.confirmDesc': 'このグループを使用しているチケットとテンプレートは、先に再割り当てする必要があります。',
  'adm.groups.confirmLabel': 'グループを削除',
  'adm.groups.confirmTitle': '「{name}」を削除しますか？',
  'adm.groups.createFirst': '最初のグループを作成',
  'adm.groups.defaultHours': '既定の営業時間',
  'adm.groups.editAria': '{name}を編集',
  'adm.groups.editGroup': 'グループを編集',
  'adm.groups.escalateHelp': 'このグループのチケットがSLAに違反した場合、通知の受信者として追加されます。',
  'adm.groups.escalateTo': 'エスカレーション先',
  'adm.groups.escalatesTo': 'エスカレーション先',
  'adm.groups.escalatesToName': 'エスカレーション先: {name}',
  'adm.groups.escalationBody': 'このグループのチケットがSLAに違反すると、エスカレーション先が担当者およびグループメンバーとともに通知の受信者として追加されます。',
  'adm.groups.escalationTitle': 'エスカレーション先',
  'adm.groups.hoursHelp': 'このグループのチケットのSLA計算に使用されます。',
  'adm.groups.manageAgents': 'エージェントを管理',
  'adm.groups.manageHours': '営業時間を管理',
  'adm.groups.manual': '手動',
  'adm.groups.manualBody': 'この製品では割り当ては手動です。ラウンドロビンや負荷ベースの自動割り当てはありません。グループの「自動割り当て」トグルは、そのグループの新しいチケットを未割り当てにするか既存の振り分けルールに従わせるかにのみ影響します。チケットの引き受けや引き継ぎは、引き続きエージェント自身が行います。',
  'adm.groups.manualTitle': '手動割り当て',
  'adm.groups.memberMany': '{count}人のメンバー',
  'adm.groups.memberOne': '{count}人のメンバー',
  'adm.groups.members': 'メンバー',
  'adm.groups.newGroup': '新しいグループ',
  'adm.groups.noEscalation': 'エスカレーション先なし',
  'adm.groups.noMatch': 'この検索に一致するグループはありません',
  'adm.groups.noMembers': 'メンバーはまだいません',
  'adm.groups.noMembersDesc': '上で有効なエージェントを選び、「メンバーを追加」を選択してください。',
  'adm.groups.remove': '削除',
  'adm.groups.routing': '振り分け',
  'adm.groups.routingMethod': '振り分け方法',
  'adm.groups.saved': 'グループを保存しました。',
  'adm.groups.searchAria': 'グループを検索',
  'adm.groups.searchPlaceholder': '名前で検索',
  'adm.groups.selectActiveAgent': '有効なエージェントを選択',
  'adm.groups.showing': '{total}件中{start}-{end}件を表示',
  'adm.groups.subtitle': 'グループはチケットの振り分けと閲覧範囲を管理します。エージェントをメンバーとして割り当て、各グループの営業時間スケジュールとエスカレーション先を選択してください。',
  'adm.groups.title': 'グループ',
  'adm.groups.tryDifferent': '別のグループ名をお試しください。',
  'adm.groups.unassigned': '未割り当て',
  'adm.groups.useNew': '「新しいグループ」を使って、チケットを特定のエージェントに振り分けます。',
  'adm.groups.zero': '0件のグループ',
  'adm.inactive': '無効',
  'adm.jira.accepted': '接続が承認されました',
  'adm.jira.accountEmail': 'Jiraアカウントのメールアドレス',
  'adm.jira.accountEmailLabel': 'アカウントのメールアドレス',
  'adm.jira.activeConn': '有効な接続',
  'adm.jira.addConnection': '接続を追加',
  'adm.jira.addTitle': 'Jira接続を追加',
  'adm.jira.added': 'Jira接続を追加しました',
  'adm.jira.apiToken': 'APIトークン',
  'adm.jira.clearSecret': '保存済みのWebhookシークレットをクリア',
  'adm.jira.confirmDesc': '保存済みの接続とチケットのリンクが削除されます。Jira課題は削除されません。',
  'adm.jira.confirmLabel': '接続を削除',
  'adm.jira.confirmTitle': '{name}を削除しますか？',
  'adm.jira.connName': '接続名',
  'adm.jira.connNamePh': 'Engineering Jira',
  'adm.jira.connectedAs': '{name}として接続中',
  'adm.jira.connectionDesk': '接続デスク',
  'adm.jira.default': 'デフォルト',
  'adm.jira.defaultConn': 'デフォルトの接続',
  'adm.jira.defaultIssueType': 'デフォルトの課題タイプ',
  'adm.jira.defaultProjectKey': 'デフォルトのプロジェクトキー',
  'adm.jira.defaults': 'デフォルト',
  'adm.jira.description': 'アカウント所有のJiraサイトを接続して、エージェントが課題をリンクし、チケットのステータスを同期できるようにします。',
  'adm.jira.editTitle': 'Jira接続を編集',
  'adm.jira.footer': '上に表示されたエンドポイントでJira Webhookを作成し、課題更新イベントを購読して、ここで設定したものと同じWebhookシークレットを使用してください。',
  'adm.jira.heading': 'サポートとエンジニアリングを同じ流れで連携',
  'adm.jira.intro': '認証情報はサーバー上で暗号化して保存され、この画面には返されません。Jiraからステータス変更をSuzukiDeskに送り返す場合は、Webhookシークレットを設定してください。',
  'adm.jira.no': 'いいえ',
  'adm.jira.noConns': 'Jira接続はまだありません',
  'adm.jira.noConnsDesc': '接続を追加すると、チケット詳細からJiraの操作を利用できます。',
  'adm.jira.noProject': 'プロジェクトなし',
  'adm.jira.pasteToken': 'トークンを貼り付け',
  'adm.jira.requestFailed': 'Jiraリクエストに失敗しました。再度お試しください。',
  'adm.jira.savedToast': 'Jira接続を保存しました',
  'adm.jira.secretConfigured': 'シークレット設定済み: {value}',
  'adm.jira.secretHint': 'Jira Webhookの作成時に同じシークレットを使用してください。',
  'adm.jira.secretOptional': '任意、16文字以上',
  'adm.jira.siteUrl': 'JiraサイトのURL',
  'adm.jira.siteUrlHint': 'URLに認証情報を含めないでください。',
  'adm.jira.syncFromJira': 'Jiraのステータスをチケットに反映',
  'adm.jira.syncSnapshot': 'リンクされた課題のスナップショット',
  'adm.jira.syncToJira': 'チケットのステータスをJiraに反映',
  'adm.jira.testConnection': '接続をテスト',
  'adm.jira.testFailed': '接続テストに失敗しました',
  'adm.jira.title': 'Jira連携',
  'adm.jira.tokenHintEdit': '現在のトークンを維持するには空白のままにしてください。',
  'adm.jira.tokenHintNew': '暗号化して保存され、再表示されません。',
  'adm.jira.tokenMissing': 'APIトークンがありません',
  'adm.jira.tokenStored': 'APIトークン保存済み',
  'adm.jira.unchanged': '（空白の場合は変更なし）',
  'adm.jira.verified': 'Jira接続を確認しました',
  'adm.jira.webhookEndpoint': 'Jira Webhookエンドポイント',
  'adm.jira.webhookSecret': 'Webhookシークレット',
  'adm.jira.whatSyncs': '同期される内容',
  'adm.jira.yes': 'はい',
  'adm.nameRequired': '名前 *',
  'adm.nextPage': '次のページ',
  'adm.notif.aud.all': '共通',
  'adm.notif.aud.customer': 'お客様',
  'adm.notif.aud.internal': '社内',
  'adm.notif.audEmail': '{audience}メール',
  'adm.notif.body': '本文',
  'adm.notif.description': 'お客様を社内ワークスペースに誘導することなく、通知の対象ごとにカスタマイズできます。',
  'adm.notif.discardDesc': 'テンプレートを切り替えると、この通知テンプレートの未保存の変更は失われます。',
  'adm.notif.discardLabel': '変更を破棄',
  'adm.notif.discardTitle': '未保存の変更を破棄しますか？',
  'adm.notif.discarded': '未保存の変更を破棄しました。',
  'adm.notif.event.automation_notification': '自動化通知',
  'adm.notif.event.group_member_added': 'グループに追加',
  'adm.notif.event.mention': 'メンション',
  'adm.notif.event.pending_input': '入力待ち',
  'adm.notif.event.sla_breach': 'SLA違反',
  'adm.notif.event.sla_escalation': 'SLAエスカレーション',
  'adm.notif.event.sla_warning': 'SLA警告',
  'adm.notif.event.ticket_assigned': 'チケット割り当て',
  'adm.notif.event.ticket_created': 'チケット作成',
  'adm.notif.event.ticket_first_response': '初回応答',
  'adm.notif.event.ticket_group_assigned': 'チケットのグループ割り当て',
  'adm.notif.event.ticket_note': 'プライベートメモ',
  'adm.notif.event.ticket_public_note': '公開メモ',
  'adm.notif.event.ticket_reply': 'チケット返信',
  'adm.notif.event.ticket_resolved': 'チケット解決',
  'adm.notif.events': 'イベント',
  'adm.notif.eventsHelp': 'イベントと受信者の対象を選択してください。',
  'adm.notif.insertVar': '{variable}を挿入',
  'adm.notif.linkNoteAgent': '対象別リンク変数{variable}は、このメールではエージェントワークスペースを開きます。',
  'adm.notif.linkNoteCustomer': '対象別リンク変数{variable}は、このメールではカスタマーポータルを開きます。',
  'adm.notif.off': 'オフ',
  'adm.notif.preview': 'プレビュー',
  'adm.notif.previewNotice': 'サンプルデータでプレビューを表示しています。',
  'adm.notif.rendering': 'レンダリング中…',
  'adm.notif.route.all': '配信対象に応じたチケットリンクを使用します。',
  'adm.notif.route.customer': 'メインのアクションでカスタマーポータルのチケットが開きます。',
  'adm.notif.route.internal': 'メインのアクションでエージェントワークスペースのチケットが開きます。',
  'adm.notif.sampleOnlyAgent': 'サンプルデータのみ — メインのアクションはエージェントワークスペースのルートを指します。',
  'adm.notif.sampleOnlyCustomer': 'サンプルデータのみ — メインのアクションはカスタマーポータルのルートを指します。',
  'adm.notif.saveChanges': '変更を保存',
  'adm.notif.saved': 'テンプレートを保存しました。',
  'adm.notif.savedBtn': '保存済み',
  'adm.notif.selectEvent': 'イベントを選択してテンプレートを編集',
  'adm.notif.selectEventDesc': '左側で通知イベントを選ぶと、件名と本文を変更できます。',
  'adm.notif.sendTest': 'テストメールを送信',
  'adm.notif.sending': '送信中…',
  'adm.notif.subject': '件名',
  'adm.notif.testQueued': 'テストメールを{email}宛てにキューに追加しました。',
  'adm.notif.title': '通知テンプレート',
  'adm.notif.urlVarTitle': '対象別リンク変数',
  'adm.notif.useTemplate': 'この対象にこのテンプレートを使用',
  'adm.notif.useTemplateHelp': 'オフにすると、安全なフォールバック通知が使用されます。',
  'adm.notif.variables': '変数',
  'adm.notif.variablesHelp': 'クリックして本文の末尾に追加',
  'adm.pagination': 'ページ送り',
  'adm.perm.cap.admin.label': '管理コンソールにアクセス',
  'adm.perm.cap.assign.label': 'チケットを割り当てる',
  'adm.perm.cap.close.label': 'チケットを閉じる',
  'adm.perm.cap.conversation_delete.label': '投稿済みの返信またはメモを削除',
  'adm.perm.cap.conversation_edit.label': '投稿済みの返信またはメモを編集',
  'adm.perm.cap.create.label': 'チケットを作成',
  'adm.perm.cap.delete.label': 'チケットを削除',
  'adm.perm.cap.edit.label': 'チケットのプロパティを編集',
  'adm.perm.cap.export.label': 'チケットをエクスポート',
  'adm.perm.cap.field_admin.label': 'チケット項目',
  'adm.perm.cap.form_admin.label': 'チケットフォーム',
  'adm.perm.cap.forward.label': 'チケットを転送',
  'adm.perm.cap.jira_link.label': 'Jira課題のリンクと管理',
  'adm.perm.cap.kb.label': 'ナレッジベースにアクセス',
  'adm.perm.cap.manage_agents.label': 'エージェント',
  'adm.perm.cap.manage_api_keys.label': 'APIキー',
  'adm.perm.cap.manage_automations.label': '自動化',
  'adm.perm.cap.manage_canned_responses.label': '定型返信',
  'adm.perm.cap.manage_email_config.label': 'メール',
  'adm.perm.cap.manage_groups.label': 'グループ',
  'adm.perm.cap.manage_jira.label': 'Jira連携',
  'adm.perm.cap.manage_kb.label': 'ナレッジベース',
  'adm.perm.cap.manage_notification_templates.label': '通知テンプレート',
  'adm.perm.cap.manage_roles.label': 'ロール',
  'adm.perm.cap.manage_tags.label': 'タグ',
  'adm.perm.cap.note.label': 'プライベートメモの追加または編集',
  'adm.perm.cap.reassign.label': '他の担当者が持つチケットを再割り当て',
  'adm.perm.cap.reopen.label': '解決済みまたは終了したチケットを再オープン',
  'adm.perm.cap.reply.label': 'お客様に公開で返信',
  'adm.perm.cap.report_access.label': 'レポートとダッシュボードを表示',
  'adm.perm.cap.reports.label': 'レポートモジュールにアクセス',
  'adm.perm.cap.resolve.label': 'チケットを解決',
  'adm.perm.cap.settings_admin.label': '設定セクションを開く（設定のナビ項目とそのインデックスページの表示に必要です。以下の各ページへのアクセスは引き続き個別に制御されます）',
  'adm.perm.cap.sla_admin.label': 'SLAポリシーと営業時間',
  'adm.perm.cap.sla_edit.desc': '下記の「設定 > SLAポリシー」権限とは別のもので、個別のチケットの期限の編集のみが対象です。',
  'adm.perm.cap.sla_edit.label': 'チケットのSLA期限を手動で上書き',
  'adm.perm.cap.tag.label': 'チケットタグを管理',
  'adm.perm.cap.thread_start.label': '会話エントリにプライベートスレッドを開始',
  'adm.perm.cap.tickets.label': 'チケットワークスペースにアクセス',
  'adm.perm.cap.view.label': '対象範囲のチケットを表示',
  'adm.perm.cat.administration.desc': '管理コンソールとその設定画面へのアクセス。',
  'adm.perm.cat.administration.label': '管理',
  'adm.perm.cat.knowledge.desc': 'チケット対応中のナレッジコンテンツの閲覧と利用。',
  'adm.perm.cat.knowledge.label': 'ナレッジベース',
  'adm.perm.cat.reporting.desc': '運用レポートとダッシュボード。',
  'adm.perm.cat.reporting.label': 'レポート',
  'adm.perm.cat.settings-pages.desc': '各設定画面へのアクセスを個別に許可します。ここで明示的にチェックするまで何も表示されません。',
  'adm.perm.cat.settings-pages.label': '設定ページ',
  'adm.perm.cat.tickets.desc': 'エージェントがチケットワークスペース内で実行できること。',
  'adm.perm.cat.tickets.label': 'チケット',
  'adm.previousPage': '前のページ',
  'adm.refresh': '更新',
  'adm.roleType.administrator': '管理者',
  'adm.roleType.agent': 'エージェント',
  'adm.roleType.collaborator': 'コラボレーター',
  'adm.roleType.customer': 'お客様',
  'adm.roleType.super_admin': 'スーパー管理者',
  'adm.roleType.supervisor': 'スーパーバイザー',
  'adm.roles.activeHelp': '有効 - 無効なロールはエージェントに割り当てられません',
  'adm.roles.agentCan': 'エージェントができること',
  'adm.roles.agentType': 'エージェントタイプ',
  'adm.roles.agentsAssignedNote': 'エージェントへのロールの割り当ては、エージェント画面から行います。',
  'adm.roles.agentsCount': 'エージェント {count}名',
  'adm.roles.agentsLabel': 'エージェント',
  'adm.roles.agentsManage': 'エージェント {count}名 - 管理',
  'adm.roles.builtIn': '（組み込み）',
  'adm.roles.builtInNote': 'これは組み込みロールです。名前の変更と無効化はできますが、削除はできません。',
  'adm.roles.builtInTitle': '組み込みロール: 編集と無効化は可能ですが、削除はできません',
  'adm.roles.categoriesAria': '権限カテゴリ',
  'adm.roles.confirmDesc': 'このロールを削除するには、割り当て済みのエージェントに別のロールを割り当てる必要があります。',
  'adm.roles.confirmLabel': 'ロールを削除',
  'adm.roles.createFirst': '最初のロールを作成',
  'adm.roles.createFirstDesc': '「新しいロール」を使って、エージェントに付与する機能を定義します。',
  'adm.roles.editRole': 'ロールを編集',
  'adm.roles.granted': '{count}件付与',
  'adm.roles.heading': 'エージェントロール',
  'adm.roles.inactive': '無効',
  'adm.roles.newRole': '新しいロール',
  'adm.roles.noAgent': 'エージェントなし',
  'adm.roles.notEnforced': '（まだ適用されていません）',
  'adm.roles.notEnforcedTitle': 'ロールには保存されますが、実行時にはまだ制限されていません',
  'adm.roles.permissions': '権限',
  'adm.roles.saved': 'ロールを保存しました。',
  'adm.roles.scopeBody': '機能は行レベルの範囲（すべて / グループ / 割り当て済み / 自分）と組み合わされるため、エージェントは自分が閲覧できるチケットに対してのみ操作できます。',
  'adm.roles.scopeTitle': '範囲は引き続き適用されます',
  'adm.roles.scrollTo': '移動先',
  'adm.roles.status': 'ステータス',
  'adm.roles.subtitle': 'エージェントのきめ細かなアクセスレベルと権限を付与または制限します。',
  'adm.roles.title': 'ロール',
  'adm.roles.typeLocked': 'ロールを保存した後は、エージェントタイプを変更できません。',
  'adm.roles.understandingBody1': 'ロールはエージェントができることを決定します。ロールを作成し、付与する機能にチェックを入れて、エージェント画面からエージェントに割り当てます。',
  'adm.roles.understandingBody2': '組み込みロールは名前の変更と無効化はできますが、削除はできません。エージェントが割り当てられているロールも削除できないため、先にそのエージェントを移動してください。',
  'adm.roles.understandingTitle': 'ロールについて',
  'adm.saveChanges': '変更を保存',
  'adm.settings.add': '{name}を追加',
  'adm.settings.back': '設定に戻る',
  'adm.settings.cannedDesc': 'チケット対応中に使用できるアカウントの返信。',
  'adm.settings.cannedEmpty': '定型返信はまだありません',
  'adm.settings.cannedEmptyDesc': 'チケットでチームが再利用できる共有返信の追加を管理者に依頼してください。',
  'adm.settings.cannedTitle': '定型返信',
  'adm.settings.col.autoAssign': '自動割り当て',
  'adm.settings.col.color': '色',
  'adm.settings.col.content': '内容',
  'adm.settings.col.createdAt': '作成日時',
  'adm.settings.col.description': '説明',
  'adm.settings.col.email': 'メール',
  'adm.settings.col.expiresAt': '有効期限',
  'adm.settings.col.fieldType': '項目タイプ',
  'adm.settings.col.firstName': '名',
  'adm.settings.col.folderId': 'フォルダーID',
  'adm.settings.col.hitCount': 'ヒット数',
  'adm.settings.col.holidays': '休日',
  'adm.settings.col.host': 'ホスト',
  'adm.settings.col.hours': '時間',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': '有効',
  'adm.settings.col.isBuiltIn': '組み込み',
  'adm.settings.col.isDefault': 'デフォルト',
  'adm.settings.col.isRequired': '必須',
  'adm.settings.col.isShared': '共有',
  'adm.settings.col.isSystem': 'システム',
  'adm.settings.col.key': 'キー',
  'adm.settings.col.label': 'ラベル',
  'adm.settings.col.language': '言語',
  'adm.settings.col.lastName': '姓',
  'adm.settings.col.lastUsedAt': '最終使用日時',
  'adm.settings.col.name': '名前',
  'adm.settings.col.options': 'オプション',
  'adm.settings.col.phone': '電話番号',
  'adm.settings.col.port': 'ポート',
  'adm.settings.col.position': '位置',
  'adm.settings.col.prefix': 'プレフィックス',
  'adm.settings.col.priority': '優先度',
  'adm.settings.col.required': '必須',
  'adm.settings.col.role': 'ロール',
  'adm.settings.col.roleId': 'ロールID',
  'adm.settings.col.scopes': 'スコープ',
  'adm.settings.col.slug': 'スラッグ',
  'adm.settings.col.status': 'ステータス',
  'adm.settings.col.stopProcessing': '処理を停止',
  'adm.settings.col.timezone': 'タイムゾーン',
  'adm.settings.col.title': 'タイトル',
  'adm.settings.col.trigger': 'トリガー',
  'adm.settings.col.type': 'タイプ',
  'adm.settings.col.updatedAt': '更新日時',
  'adm.settings.col.usageCount': '使用回数',
  'adm.settings.col.username': 'ユーザー名',
  'adm.settings.confirmDesc': 'この操作は元に戻せません。',
  'adm.settings.confirmTitle': '{name}を削除しますか？',
  'adm.settings.count': '{title} {count}件',
  'adm.settings.create': '作成',
  'adm.settings.empty': '{title}はまだありません',
  'adm.settings.emptyAdd': '上のフォームを使って、最初の{name}を追加してください。',
  'adm.settings.emptyOther': '設定されたエントリがここに表示されます。',
  'adm.settings.homeDesc': 'ユーザー、チケットのワークフロー、サービスレベル、連携を設定します。',
  'adm.settings.manage': '{title}を管理します。',
  'adm.settings.noPages': '利用できる設定ページはありません',
  'adm.settings.noPagesDesc': '必要な設定ページへのアクセス許可をスーパー管理者に依頼してください。',
  'adm.settings.notFound': '設定ページが見つかりません',
  'adm.settings.notFoundDesc': '続行するには設定項目を選択してください。',
  'adm.settings.res.agents.field.email': 'メール',
  'adm.settings.res.agents.field.firstName': '名',
  'adm.settings.res.agents.field.lastName': '姓',
  'adm.settings.res.agents.field.password': '仮パスワード',
  'adm.settings.res.agents.field.roleId': 'ロールID',
  'adm.settings.res.agents.one': 'エージェント',
  'adm.settings.res.agents.title': 'エージェント',
  'adm.settings.res.api-keys.field.name': 'キー名',
  'adm.settings.res.api-keys.one': 'APIキー',
  'adm.settings.res.api-keys.title': 'APIキー',
  'adm.settings.res.automations.field.description': '説明',
  'adm.settings.res.automations.field.name': '名前',
  'adm.settings.res.automations.one': '自動化',
  'adm.settings.res.automations.title': '自動化',
  'adm.settings.res.business-hours.field.name': '名前',
  'adm.settings.res.business-hours.field.timezone': 'タイムゾーン',
  'adm.settings.res.business-hours.one': '営業時間エントリ',
  'adm.settings.res.business-hours.title': '営業時間',
  'adm.settings.res.canned-responses.field.content': '返信内容',
  'adm.settings.res.canned-responses.field.title': 'タイトル',
  'adm.settings.res.canned-responses.one': '定型返信',
  'adm.settings.res.canned-responses.title': '定型返信',
  'adm.settings.res.email.field.host': 'SMTPホスト',
  'adm.settings.res.email.field.name': '名前',
  'adm.settings.res.email.field.port': 'SMTPポート',
  'adm.settings.res.email.field.username': 'ユーザー名',
  'adm.settings.res.email.one': 'メール設定',
  'adm.settings.res.email.title': 'メール設定',
  'adm.settings.res.fields.one': 'チケット項目',
  'adm.settings.res.fields.title': 'チケット項目',
  'adm.settings.res.forms.field.label': '表示ラベル',
  'adm.settings.res.forms.field.name': '項目名',
  'adm.settings.res.forms.field.type': '項目タイプ',
  'adm.settings.res.forms.one': 'フォームまたはカスタム項目',
  'adm.settings.res.forms.title': 'フォームとカスタム項目',
  'adm.settings.res.groups.field.description': '説明',
  'adm.settings.res.groups.field.name': '名前',
  'adm.settings.res.groups.one': 'グループ',
  'adm.settings.res.groups.title': 'グループ',
  'adm.settings.res.jira.one': 'Jira連携',
  'adm.settings.res.jira.title': 'Jira連携',
  'adm.settings.res.kb.field.content': '記事の内容',
  'adm.settings.res.kb.field.folderId': 'フォルダーID',
  'adm.settings.res.kb.field.title': '記事のタイトル',
  'adm.settings.res.kb.one': 'ナレッジベース記事',
  'adm.settings.res.kb.title': 'ナレッジベース管理',
  'adm.settings.res.notification-templates.one': '通知テンプレート',
  'adm.settings.res.notification-templates.title': '通知テンプレート',
  'adm.settings.res.roles.field.description': '説明',
  'adm.settings.res.roles.field.name': '名前',
  'adm.settings.res.roles.field.type': 'ロールタイプ',
  'adm.settings.res.roles.one': 'ロール',
  'adm.settings.res.roles.title': 'ロール',
  'adm.settings.res.sla.field.description': '説明',
  'adm.settings.res.sla.field.name': '名前',
  'adm.settings.res.sla.one': 'SLAポリシー',
  'adm.settings.res.sla.title': 'SLAポリシー',
  'adm.settings.res.tags.field.name': '名前',
  'adm.settings.res.tags.one': 'タグ',
  'adm.settings.res.tags.title': 'タグ',
  'adm.settings.title': '設定',
  'adm.status': 'ステータス',

  'sla.edit': '編集',
  'sla.active': '有効',
  'sla.inactive': '無効',
  'sla.default': 'デフォルト',
  'sla.yes': 'はい',
  'sla.no': 'いいえ',
  'sla.description': '説明',
  'sla.status': 'ステータス',
  'sla.notConfigured': '未設定',
  'sla.minutesValue': '{value}分',
  'sla.invalidServerValue': 'サーバーの値が無効です',
  'sla.statusSemantics.title': 'チケットステータスの意味付け',
  'sla.statusSemantics.description': '有効な各ステータスには明示的なSLA契約があります。SLAを一時停止するステータスと、SLAを停止するステータスは同時に指定できません。',
  'sla.statusSemantics.conflict': 'ステータスがSLAの一時停止と停止を同時に行うことはできません。',
  'sla.statusSemantics.emptyTitle': 'ステータス定義がありません',
  'sla.statusSemantics.emptyDescription': 'このアカウントでステータス定義を設定すると、ここに表示されます。',
  'sla.statusSemantics.colPauses': 'SLAを一時停止',
  'sla.statusSemantics.colStops': 'SLAを停止',
  'sla.statusSemantics.pausesAria': '{label}はSLAを一時停止',
  'sla.statusSemantics.stopsAria': '{label}はSLAを停止',
  'sla.preview.title': '読み取り専用のチケットプレビュー',
  'sla.preview.description': '実際のSLAサイクルで使用されるアカウント単位の評価ロジックを実行します。このプレビューがポリシーやチケットを書き込むことはありません。',
  'sla.preview.priority': '優先度',
  'sla.preview.group': 'グループ',
  'sla.preview.anyGroup': '任意のグループ',
  'sla.preview.company': '会社',
  'sla.preview.anyCompany': '任意の会社',
  'sla.preview.source': 'ソース',
  'sla.preview.anySource': '任意のソース',
  'sla.preview.ticketType': 'チケットタイプ',
  'sla.preview.anyTicketType': '任意のチケットタイプ',
  'sla.preview.representativeStart': '代表的な開始時刻',
  'sla.preview.calculating': '計算中…',
  'sla.preview.run': 'プレビューを実行',
  'sla.preview.configAttention': '設定の確認が必要です',
  'sla.preview.selectedPolicy': '選択されたポリシー',
  'sla.preview.noPolicy': 'ポリシーなし',
  'sla.preview.evaluationOrder': '評価順序',
  'sla.preview.firstMatching': '最初に一致したポリシー',
  'sla.preview.calculationMode': '計算モード',
  'sla.preview.modeBusinessHours': '営業時間',
  'sla.preview.modeBusinessHoursNamed': '営業時間 · {name}',
  'sla.preview.mode247': '24時間365日の経過時間',
  'sla.preview.modeNone': '計算なし',
  'sla.preview.thresholds': '個別のしきい値',
  'sla.preview.colMetric': '指標',
  'sla.preview.colTarget': '目標',
  'sla.preview.colWarning': '警告',
  'sla.preview.colDue': '期限 / 違反',
  'sla.preview.colEscalation': 'エスカレーション',
  'sla.preview.colState': '状態',
  'sla.preview.metricFirstResponse': '初回応答',
  'sla.preview.metricResolution': '解決',
  'sla.preview.trace': 'ポリシー評価トレース',
  'sla.preview.selected': '選択済み',
  'sla.preview.matchedAfterSelection': '選択後に一致',
  'sla.preview.skipped': 'スキップ',
  'sla.preview.showTrace': '計算トレースを表示',
  'sla.state.not_configured': '未設定',
  'sla.state.running': '進行中',
  'sla.state.paused': '一時停止中',
  'sla.state.warning': '警告',
  'sla.state.breached': '違反',
  'sla.state.met': '達成',
  'sla.state.escalated': 'エスカレーション済み',
  'sla.state.pending': '保留',
  'sla.state.stopped': '停止',
  'sla.state.on_track': '順調',
  'sla.state.at_risk': 'リスクあり',
  'sla.list.subtitle': '優先度ごとに初回応答と解決の目標を設定します。ポリシーは上から順に評価され、チケットの条件に最初に一致したものが適用されます。',
  'sla.list.newPolicy': '新しいポリシー',
  'sla.list.emptyTitle': '最初のSLAポリシーを作成',
  'sla.list.emptyDescription': '「新しいポリシー」を使って、優先度ごとに初回応答と解決の目標を設定します。',
  'sla.list.moveUp': '上へ移動',
  'sla.list.moveDown': '下へ移動',
  'sla.list.frShort': '初回応答: {value}',
  'sla.list.resolveShort': '解決: {value}',
  'sla.list.escalateShort': 'エスカレーション: +{value}',
  'sla.list.deactivate': '無効にする',
  'sla.list.activate': '有効にする',
  'sla.list.setDefault': 'デフォルトに設定',
  'sla.list.duplicate': '複製',
  'sla.list.deleteTitle': '「{name}」を削除しますか？',
  'sla.list.deleteDescription': 'このポリシーに一致していたチケットには、次に利用可能なSLAポリシーが適用されます。',
  'sla.list.deleteConfirm': 'ポリシーを削除',
  'sla.conditions.groups': '{count}個のグループ',
  'sla.conditions.companies': '{count}社の会社',
  'sla.conditions.sources': 'ソース: {list}',
  'sla.conditions.ticketTypes': '{count}個のチケットタイプ',
  'sla.conditions.anyOf': 'いずれか',
  'sla.conditions.allOf': 'すべて',
  'sla.conditions.summary': '条件（{mode}）: {parts}',
  'sla.edit.newTitle': '新しいSLAポリシー',
  'sla.edit.editTitle': 'SLAポリシーを編集',
  'sla.edit.saved': 'SLAポリシーを保存しました。',
  'sla.edit.name': '名前',
  'sla.edit.appliesToPriority': '適用する優先度',
  'sla.edit.evaluationOrder': '評価順序',
  'sla.edit.evaluationOrderHint': 'このアカウントでは、位置が小さいものから先に評価されます。',
  'sla.edit.defaultPolicy': 'デフォルトポリシー',
  'sla.edit.useAsDefault': '他のポリシーに一致しない場合にデフォルトとして使用',
  'sla.edit.targets': 'SLA目標',
  'sla.edit.firstResponse': '初回応答',
  'sla.edit.resolution': '解決',
  'sla.edit.autoAt75': '75%で自動',
  'sla.edit.enabledAfter': '{value}後に有効',
  'sla.edit.clearEscalation': 'エスカレーション目標を明示的にクリア',
  'sla.edit.clearEscalationHint': 'nullを送信します。チェックしない場合、項目は送信されず保存済みの値が維持されます。',
  'sla.edit.firstResponseMinutes': '初回応答（分）',
  'sla.edit.resolutionMinutes': '解決（分）',
  'sla.edit.escalateAfter': 'エスカレーションまでの時間（解決期限からの超過分）',
  'sla.edit.notSet': '未設定',
  'sla.edit.remindersNote': 'リマインダーは、初回応答と解決の期間の75%の時点で自動的に送信されます。エスカレーションは、解決目標が設定した分数を超過した時点で、チケットのグループのエスカレーション担当エージェント（グループで設定）に通知します。',
  'sla.edit.conditions': '条件',
  'sla.edit.conditionsHint': 'すべての値に一致させるには、グループのチェックを外したままにします',
  'sla.edit.matchMode': '一致モード:',
  'sla.edit.matchAll': 'すべての条件に一致',
  'sla.edit.matchAny': 'いずれかの条件に一致',
  'sla.edit.groups': 'グループ',
  'sla.edit.companies': '会社',
  'sla.edit.sources': 'ソース',
  'sla.edit.ticketTypes': 'チケットタイプ',
  'sla.bh.subtitle': 'SLAポリシーが期限の計算に使用する週間スケジュールと休日カレンダーを定義します。',
  'sla.bh.newCalendar': '新しいカレンダー',
  'sla.bh.emptyTitle': '最初の営業時間カレンダーを作成',
  'sla.bh.emptyDescription': '「新しいカレンダー」を使って、SLAポリシーが基準とする週間スケジュールを定義します。',
  'sla.bh.accountDefault': 'アカウントの既定',
  'sla.bh.closedEveryDay': '毎日休業',
  'sla.bh.openEveryDay': '毎日営業',
  'sla.bh.openDaysOne': '週1日営業',
  'sla.bh.openDaysMany': '週{count}日営業',
  'sla.bh.holidayOne': '休日1日',
  'sla.bh.holidayMany': '休日{count}日',
  'sla.bh.deleteTitle': '「{name}」を削除しますか？',
  'sla.bh.deleteDescription': 'このスケジュールを使用しているSLAポリシーとグループは、アカウントの既定に切り替わります。',
  'sla.bh.deleteConfirm': 'スケジュールを削除',
  'sla.bh.newTitle': '新しい営業時間カレンダー',
  'sla.bh.editTitle': '営業時間を編集',
  'sla.bh.saved': '営業時間を保存しました。',
  'sla.bh.timezone': 'タイムゾーン',
  'sla.bh.defaultCalendar': 'デフォルトカレンダー',
  'sla.bh.useAsDefault': '独自のカレンダーを指定していないSLAポリシーとグループに使用',
  'sla.bh.weeklySchedule': '週間スケジュール',
  'sla.bh.colDay': '曜日',
  'sla.bh.colOpen': '営業',
  'sla.bh.colStart': '開始',
  'sla.bh.colEnd': '終了',
  'sla.bh.dayOpenAria': '{day}は営業',
  'sla.bh.dayStartAria': '{day}の開始時刻',
  'sla.bh.dayEndAria': '{day}の終了時刻',
  'sla.bh.holidayCalendar': '休日カレンダー',
  'sla.bh.saveFirst': '先にこのカレンダーを保存してから、休日を追加してください。',
  'sla.bh.holidayName': '休日名',
  'sla.bh.date': '日付',
  'sla.bh.addHoliday': '休日を追加',
  'sla.bh.noHolidays': '休日はまだありません',
  'sla.bh.noHolidaysHint': '上で日付付きの休日を追加すると、SLA計算から除外されます。',
  'sla.bh.remove': '削除',
  'sla.day.monday': '月曜日',
  'sla.day.tuesday': '火曜日',
  'sla.day.wednesday': '水曜日',
  'sla.day.thursday': '木曜日',
  'sla.day.friday': '金曜日',
  'sla.day.saturday': '土曜日',
  'sla.day.sunday': '日曜日',

  'set.ftype.single_line_text': '1行テキスト',
  'set.ftype.multi_line_text': '複数行テキスト',
  'set.ftype.dropdown': 'ドロップダウン',
  'set.ftype.checkbox': 'チェックボックス',
  'set.ftype.radio': 'ラジオボタン',
  'set.ftype.multiselect': '複数選択',
  'set.ftype.lookup': 'ルックアップ関連',
  'set.ftype.dependent': '依存項目',
  'set.ftype.date': '日付',
  'set.ftype.number': '数値',
  'set.ftype.decimal': '小数',
  'set.ftype.desc.lookup': 'システムのソースからレコードを選択します。',
  'set.ftype.desc.single_line_text': '短いテキスト値。',
  'set.ftype.desc.multi_line_text': '長文のテキスト値。',
  'set.ftype.desc.checkbox': '真または偽の値。',
  'set.ftype.desc.dropdown': '正規化された選択肢から1つを選択します。',
  'set.ftype.desc.dependent': '選択肢は親項目に依存します。',
  'set.ftype.desc.date': 'カレンダーの日付値。',
  'set.ftype.desc.number': '整数値。',
  'set.ftype.desc.decimal': '小数値。',
  'set.src.STATIC': '固定の選択肢',
  'set.src.AGENTS': 'エージェント',
  'set.src.USERS': 'ユーザー / お客様',
  'set.src.GROUPS': 'グループ',
  'set.src.ROLE': 'ロール',
  'set.src.COUNTRIES': '国',
  'set.src.CUSTOM': 'カスタムドロップダウンリスト',
  'set.settings': '設定',
  'set.ticketFields': 'チケット項目',
  'set.ticketForms': 'チケットフォーム',
  'set.requestFailed': 'リクエストに失敗しました。再度お試しください。',
  'set.refresh': '更新',
  'set.saving': '保存中…',
  'set.saveChanges': '変更を保存',
  'set.default': 'デフォルト',
  'set.published': '公開済み',
  'set.draft': '下書き',
  'set.publish': '公開',
  'set.unpublish': '非公開にする',
  'set.deleteForm': 'フォームを削除',
  'set.description': '説明',
  'set.relationshipSource': '関連のソース',
  'set.dependsOn': '{field}に依存',
  'set.deleteFormTitle': '「{name}」を削除しますか？',
  'set.deleteFormDescription': 'このチケットフォームとその設定は完全に削除されます。',
  'set.formIdRequired': 'フォームIDが必要です。',
  'set.formNotFound': 'チケットフォームが見つかりません。',
  'set.tf.removeOption': '{label}を削除',
  'set.tf.noOptions': '選択肢はまだ定義されていません。',
  'set.tf.addOptionPlaceholder': '選択肢を追加...',
  'set.tf.add': '追加',
  'set.tf.dependsOnField': '依存する項目',
  'set.tf.selectParent': '— 親項目を選択 —',
  'set.tf.parentHelp': '選択された値によってこの項目の選択肢が決まる、親のドロップダウン項目。',
  'set.tf.optionMappings': '選択肢のマッピング',
  'set.tf.savingParen': '（保存中...）',
  'set.tf.mappingsError': 'マッピングを読み込めません',
  'set.tf.archivedParen': '（アーカイブ済み）',
  'set.tf.mappedCount': '{count}件マッピング済み',
  'set.tf.saveFirst': '選択肢のマッピングを設定するには、先に項目を保存してください。',
  'set.tf.newField': '新しい{type}',
  'set.tf.pageDescription': 'インポートした項目の定義、表示設定、必須ルール、チケットフォームで使用する順序を管理します。',
  'set.tf.addField': '項目を追加',
  'set.tf.addFieldHelp': 'タイプを項目リストにドラッグするか、「追加」を使用してください。',
  'set.tf.addType': '{type}を追加',
  'set.tf.registry': '項目レジストリ',
  'set.tf.savingOrder': '順序を保存中…',
  'set.tf.searchAria': 'チケット項目を検索',
  'set.tf.searchPlaceholder': '名前またはキーで検索...',
  'set.tf.filterAria': '項目タイプで絞り込み',
  'set.tf.allTypes': 'すべての項目タイプ',
  'set.tf.emptyFirstTitle': '最初のチケット項目を追加',
  'set.tf.emptyFirstDesc': 'パレットから項目タイプをドラッグするか、「追加」を使用して作成します。',
  'set.tf.emptyFilterTitle': 'これらのフィルターに一致する項目はありません',
  'set.tf.emptyFilterDesc': '別の検索語を試すか、項目タイプのフィルターを広げてください。',
  'set.tf.archived': 'アーカイブ済み',
  'set.tf.dependent': '依存',
  'set.tf.customerVisible': 'お客様に表示',
  'set.tf.internal': '社内',
  'set.tf.configuration': '項目の設定',
  'set.tf.selectTitle': '設定する項目を選択',
  'set.tf.selectDesc': 'レジストリから項目を選ぶと、ラベル、ルール、表示設定を編集できます。',
  'set.tf.externalId': '外部ID: {value}',
  'set.tf.sourceRenderer': 'ソース: {source} · レンダラー: {renderer}',
  'set.tf.optionSource': '選択肢のソース: {value}',
  'set.tf.dependsOnKey': '依存先: {value}',
  'set.tf.internalLabel': '社内向けラベル',
  'set.tf.customerLabel': 'お客様向けラベル',
  'set.tf.relationshipHelp': '実行時にルックアップ値を取得する場所を決定します。',
  'set.tf.validationVisibility': '検証と表示設定',
  'set.tf.requiredAgents': 'エージェントに必須',
  'set.tf.requiredCustomers': 'お客様に必須',
  'set.tf.requiredClosure': 'クローズ時に必須',
  'set.tf.displayedCustomers': 'お客様に表示',
  'set.tf.customersEdit': 'お客様が編集可能',
  'set.tf.customersFilter': 'お客様が絞り込み可能',
  'set.tf.active': '有効',
  'set.tf.dropdownOptions': 'ドロップダウンの選択肢 ({count})',
  'set.tf.archiveTitle': '「{name}」をアーカイブしますか？',
  'set.tf.archiveDesc': 'この項目は無効になり、新しいチケットでは使用できなくなります。既存のチケットデータは保持されます。',
  'set.tf.archiveField': '項目をアーカイブ',
  'set.tf.alreadyArchived': 'アーカイブ済み',
  'set.tf.archivedNote': 'アーカイブ済みの項目は、過去の値のために引き続き利用できます。',
  'set.tfm.systemUser': 'システム',
  'set.tfm.untitled': '無題のフォーム',
  'set.tfm.pageDescription': '再利用可能なフォームを作成し、エージェントとお客様が使用できるインポート済み項目を選択します。',
  'set.tfm.newForm': '新しいフォーム',
  'set.tfm.creating': '作成中…',
  'set.tfm.allForms': 'すべてのフォーム',
  'set.tfm.configuredOne': '設定済みのフォーム: {count}件',
  'set.tfm.configuredMany': '設定済みのフォーム: {count}件',
  'set.tfm.filter': 'フィルター',
  'set.tfm.searchAria': 'チケットフォームを検索',
  'set.tfm.searchPlaceholder': 'フォームを検索…',
  'set.tfm.status': 'ステータス',
  'set.tfm.allStatuses': 'すべてのステータス',
  'set.tfm.emptyFilterTitle': 'これらのフィルターに一致するフォームはありません',
  'set.tfm.emptyFilterDesc': '別の検索語を試すか、ステータスのフィルターを広げてください。',
  'set.tfm.emptyFirstTitle': '最初のチケットフォームを作成',
  'set.tfm.emptyFirstDesc': 'フォームを作成して、インポート済み項目の設定を始めます。',
  'set.tfm.createFirst': '最初のフォームを作成',
  'set.tfm.colName': '名前',
  'set.tfm.colCreatedAt': '作成日時',
  'set.tfm.colUpdatedBy': '最終更新者',
  'set.tfm.colUpdatedAt': '最終更新日時',
  'set.tfm.colPortals': '関連するポータル',
  'set.tfm.colActions': '操作',
  'set.tfm.notConfigured': '未設定',
  'set.tfm.actionsFor': '{name}の操作',
  'set.tfm.editForm': 'フォームを編集',
  'set.tb.section.default.title': '既定の項目',
  'set.tb.section.default.desc': 'ソースシステムからインポートされた、基本的なサポートワークフローの項目。',
  'set.tb.section.custom.title': 'カスタム項目',
  'set.tb.section.custom.desc': 'サポートプロセス向けに設定された追加の項目。',
  'set.tb.section.nested.title': 'ネストされた項目',
  'set.tb.section.nested.desc': '選択肢が親項目に従う依存項目。',
  'set.tb.discardTitle': '未保存の変更を破棄しますか？',
  'set.tb.discardDesc': 'このチケットフォームへの編集は保存されていません。',
  'set.tb.leave': '保存せずに移動',
  'set.tb.nameRequired': 'フォーム名は必須です。',
  'set.tb.saved': 'フォームを保存しました。',
  'set.tb.nowPublished': 'フォームを公開しました。',
  'set.tb.nowUnpublished': 'フォームを非公開にしました。',
  'set.tb.admin': '管理',
  'set.tb.builder': 'ビルダー',
  'set.tb.titleAria': 'フォームタイトル',
  'set.tb.defaultLocked': 'デフォルト / ロック済み',
  'set.tb.previewPortal': 'ポータルでプレビュー',
  'set.tb.configureTitle': 'このフォームに含める項目を設定します。',
  'set.tb.configureDesc': '変更は「変更を保存」を選択するとサポートデスクのデータベースに保存されます。必須項目は有効のままです。',
  'set.tb.formDetails': 'フォームの詳細',
  'set.tb.formDetailsHelp': '管理者がこのフォームの使いどころを判断できるよう、わかりやすい説明を入力してください。',
  'set.tb.descPlaceholder': 'このフォームをどのような場合に使用するかを入力…',
  'set.tb.importedFields': 'インポート済みの項目',
  'set.tb.importedHelp': 'ドラッグして項目を並べ替えます。スイッチで、この項目をフォームに含めるかどうかを切り替えます。',
  'set.tb.noneInSection': 'このセクションにインポート済みの項目はありません。',
  'set.tb.dragReorder': 'ドラッグして並べ替え',
  'set.tb.required': '必須',
  'set.tb.nested': 'ネスト',
  'set.tb.enableField': '{label}を有効にする',
  'set.tb.enabled': '有効',
  'set.tb.disabled': '無効',
  'set.tb.emptyTitle': '設定する項目はまだありません',
  'set.tb.emptyDesc': 'チケット項目をインポートして、このフォームの作成を始めます。',
  'set.tb.deleting': '削除中…',
  'set.tp.loadError': 'フォームのプレビューを読み込めません。',
  'set.tp.preview': 'プレビュー',
  'set.tp.customerPreview': 'お客様向けプレビュー',
  'set.tp.backToBuilder': 'ビルダーに戻る',
  'set.tp.modeTitle': 'プレビューモード',
  'set.tp.modeDesc': 'これは送信されないプレビューです。有効なすべての項目が、保存されたフォームの順序で表示されます。',
  'set.tp.emptyTitle': '有効な項目はまだありません',
  'set.tp.emptyDesc': 'フォームビルダーで項目を有効にすると、このプレビューに表示されます。',

  'por.error.generic': 'リクエストを完了できません。',
  'por.error.requestNotFound': 'リクエストが見つかりません。',
  'por.error.formUnavailable': 'リクエストフォームは利用できません。',
  'por.error.articleNotFound': '記事が見つかりません。',
  'por.error.selectRating': '1から5の評価を選択してください。',
  'por.tab.all': 'すべて',
  'por.list.title': 'マイサポートリクエスト',
  'por.list.description': 'リクエストの状況を確認し、サポートチームに返信できます。',
  'por.list.newRequest': '新しいリクエスト',
  'por.list.knowledgeBase': 'ナレッジベース',
  'por.list.filterByStatus': 'ステータスでリクエストを絞り込み',
  'por.list.searchPlaceholder': '件名で検索…',
  'por.list.count': '{count}件のリクエスト',
  'por.list.countOne': '{count}件のリクエスト',
  'por.list.emptyFilteredTitle': 'このビューに一致するリクエストはありません',
  'por.list.emptyTitle': 'リクエストはまだありません',
  'por.list.emptyFilteredDescription': '「すべて」タブを開くか、別の検索語をお試しください。',
  'por.list.emptyDescription': 'リクエストを送信すると、サポートチームが対応します。',
  'por.list.submitFirst': '最初のリクエストを送信',
  'por.col.request': 'リクエスト',
  'por.col.subject': '件名',
  'por.col.status': 'ステータス',
  'por.col.priority': '優先度',
  'por.col.created': '作成日',
  'por.detail.myRequests': 'マイリクエスト',
  'por.detail.reopen': 'このリクエストを再オープン',
  'por.detail.attachments': '添付ファイル',
  'por.detail.download': 'ダウンロード',
  'por.detail.conversation': '会話',
  'por.detail.noReplies': '返信はまだありません',
  'por.detail.noRepliesHint': '下に返信を追加すると、サポートチームが対応します。',
  'por.detail.reply': '返信',
  'por.detail.replyPlaceholder': '返信を入力',
  'por.detail.sending': '送信中…',
  'por.detail.sendReply': '返信を送信',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': '{name}を削除',
  'por.submit.newRequest': '新しいリクエスト',
  'por.submit.defaultTitle': 'サポートリクエストを送信',
  'por.submit.intro': '以下の項目に入力して、リクエストを送信してください。',
  'por.submit.subjectRequired': '件名は必須です',
  'por.submit.descriptionRequired': '説明は必須です',
  'por.submit.attachments': '添付ファイル',
  'por.submit.submitting': '送信中…',
  'por.submit.submit': 'リクエストを送信',
  'por.kb.portal': 'ポータル',
  'por.kb.title': 'ナレッジベース',
  'por.kb.description': 'リクエストを送信する前に、回答を探してみましょう。',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': '検索結果',
  'por.kb.searchPlaceholder': '記事を検索',
  'por.kb.emptyTitle': '公開済みの記事はまだありません',
  'por.kb.emptyDescription': 'リクエストを送信すると、サポートチームが直接対応します。',
  'por.kb.noFolders': 'フォルダーなし',
  'por.kb.articles': '{count}件の記事',
  'por.kb.articlesOne': '{count}件の記事',
  'por.kb.noMatch': '「{query}」に一致する記事はありません',
  'por.kb.folderEmpty': 'このフォルダーに記事はまだありません',
  'por.kb.noMatchHint': 'より短い検索語を試すか、代わりにリクエストを送信してください。',
  'por.kb.folderEmptyHint': '別のフォルダーを参照するか、代わりにリクエストを送信してください。',
  'por.kb.submitRequest': 'リクエストを送信',
  'por.kb.views': '{count}回表示',
  'por.kb.thanks': 'フィードバックありがとうございます！',
  'por.kb.helpful': 'この記事は役に立ちましたか？',
  'por.kb.yes': 'はい',
  'por.kb.no': 'いいえ',
  'por.csat.thanksTitle': 'フィードバックありがとうございます',
  'por.csat.thanksBody': '回答を記録しました。',
  'por.csat.title': '対応はいかがでしたか？',
  'por.csat.request': 'リクエスト #{number}: {subject}',
  'por.csat.rating': '評価',
  'por.csat.stars': '星{count}つ',
  'por.csat.comment': 'コメント',
  'por.csat.submit': 'フィードバックを送信',
  'agents.tempPassword.title': '一時パスワード',
  'agents.tempPassword.help': 'このエージェントの一時パスワードを設定します。次回のサインイン時に新しいパスワードの設定が求められます。12文字以上。',
  'agents.tempPassword.button': '一時パスワードを設定',
  'agents.tempPassword.saving': '設定中…',
  'agents.tempPassword.error': '一時パスワードを設定できませんでした。',
  'ui.showPassword': 'パスワードを表示',
  'ui.hidePassword': 'パスワードを非表示',
  'dashboard.awaitingResolutionConfirmation': '解決の確認待ち',
  'dashboard.awaitingUserReply': 'ユーザーの返信待ち',
  'dashboard.changeRequests': '変更リクエスト',
  'agents.tempPassword.successEmailed': '一時パスワードを設定し、エージェントにメールで送信しました。',
  'agents.tempPassword.successNotEmailed': '一時パスワードを設定しましたが、メールを送信できませんでした。安全な方法でエージェントにパスワードを伝えてください。',
} as const;

export default ja;
